/* ============================================================
   PARTNER PORTAL — Ajout de photographies (Uploadcare 3.x isolé)
   ELOISE ACCESSOIRES · lot 12D-B
   - JS natif, IIFE, mode strict. Namespace : window.__pp.
   - Aucune dépendance, aucun build, aucun fetch, aucun payload.
   - Aucun input file, aucun fallback natif, aucun hidden input.
   - Uploadcare chargé paresseusement, une seule fois, hors design_mode.
   - Isolation stricte : ne réutilise jamais window._ep / epCard / .ep__.
   - Validation de taille : validateur personnalisé passé à openDialog
     (mécanisme garanti du Widget 3.x) + revérification de info.size.
     N'appelle PAS window.uploadcare.validators.fileSizeLimit (non confirmé).
   ============================================================ */
(function () {
  'use strict';

  var CDN = 'https://ucarecdn.com/libs/widget/3.x/uploadcare.full.min.js';
  var SUBMIT_ENDPOINT = '/apps/partner-portal/professional-requests';
  var ALLOWED_EXT = ['jpg', 'jpeg', 'png', 'webp'];
  /* Proportions de reference, par role. Ces deux nombres ne servent plus qu'a
     un rapport : leur valeur absolue n'est plus opposée a la définition d'un
     fichier (voir computeWarnings).

     La proportion, elle, tient pour les trois tailles de lampe. Le rapport
     circonference / hauteur du cylindre vaut 1,85 sur la petite (Ø 10, h 17),
     1,91 sur la moyenne (Ø 14, h 23) et 1,94 sur la grande (Ø 17, h 27,5) :
     un panoramique reste, dans les trois cas, environ deux fois plus large que
     haut. C'est une propriété de la forme, pas de la taille. */
  var TARGET = {
    panoramic: { w: 4080, h: 2100 },
    front: { w: 2040, h: 2100 },
    back: { w: 2040, h: 2100 }
  };
  var ROLE_LABEL = {
    panoramic: 'Photographie panoramique',
    front: 'Face avant',
    back: 'Face arrière'
  };
  var ROLE_ALT = {
    panoramic: 'Aperçu de la photographie panoramique',
    front: 'Aperçu de la face avant',
    back: 'Aperçu de la face arrière'
  };
  /* Ces lignes annonçaient une dimension unique par rôle, comme si un seul
     format valait pour les trois tailles de lampe. C'était faux dès l'ajout du
     choix de modèle, et un photographe qui recadre à ces valeurs détruit de la
     matière pour rien. Le cadre dit désormais ce qu'il attend vraiment : de la
     définition, et quelle face. L'atelier recadre au modèle retenu.
     computeWarnings ne vérifie plus la définition : il ne reste que le
     cadrage, dont la proportion vaut pour les trois tailles. */
  var ROLE_HINT = {
    panoramic: 'Tout le tour du cylindre · la plus haute définition possible',
    front: 'La plus haute définition possible',
    back: 'La plus haute définition possible'
  };
  var RATIO_TOLERANCE = 0.05;

  /* Nombre d'exemplaires : entier, de 1 a 50. Les memes bornes sont posees sur
     l'element (min/max/step) ; celles-ci servent au controle de secours, que le
     navigateur soit contourne ou simplement permissif. Le serveur tranche. */
  var QUANTITE_MIN = 1;
  var QUANTITE_MAX = 50;

  /* Lit une quantite SAISIE et n'accepte qu'un entier dans les bornes.
     Renvoie null pour tout le reste : vide, 0, negatif, decimal, texte,
     notation exponentielle. parseInt est volontairement ecarte, il accepterait
     « 5abc » et tronquerait « 1.5 » en 1 — deux valeurs qu'il faut refuser,
     pas corriger en silence. */
  function lireQuantite(brut) {
    if (typeof brut !== 'string') { brut = String(brut == null ? '' : brut); }
    var v = brut.trim();
    if (!/^[0-9]+$/.test(v)) { return null; }
    var n = Number(v);
    if (!isFinite(n) || n < QUANTITE_MIN || n > QUANTITE_MAX) { return null; }
    return n;
  }

  /* Montant en euros, ecriture francaise : « 66,75 € ». */
  function formatEuros(montant) {
    return montant.toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  /* Totaux de la commande, a partir des DEUX prix unitaires lus sur la ligne de
     tarif (data-pp-tarif-ht et data-pp-tarif-ttc) et de la quantite.

     Le HT n'est plus deduit du TTC. Il etait converti au taux de TVA, ce qui
     donnait 61,25 pour deux petites lampes la ou le tableau affiche 30,63 :
     le total ne retombait pas sur la ligne que le partenaire venait de lire.
     Le HT affiche est donc desormais le HT du tableau multiplie par la
     quantite — une seule et meme ecriture des prix, du tableau au total.

     Les deux calculs se font EN CENTIMES : multiplier un flottant par une
     quantite accumule les erreurs de representation, et 66.75 * 3 ne vaut pas
     toujours 200.25 exactement en virgule flottante. */
  function totauxCommande(unitaireHT, unitaireTTC, quantite) {
    var ht = (Math.round(unitaireHT * 100) * quantite) / 100;
    var ttc = (Math.round(unitaireTTC * 100) * quantite) / 100;
    return { ht: ht, ttc: ttc };
  }

  /* Compteurs de caractères (max métier + seuil visuel d'approche) */
  var COUNTER_CONF = {
    partner_internal_reference: { max: 50, threshold: 46, name: 'pp_partner_internal_reference' },
    text: { max: 50, threshold: 46, name: 'pp_text' },
    instructions: { max: 250, threshold: 230, name: 'pp_instructions' }
  };

  /* Champs du client final (ordre = ordre DOM ; address2 seul facultatif) */
  var EC_FIELDS = [
    { key: 'first_name', required: true },
    { key: 'last_name', required: true },
    { key: 'address1', required: true },
    { key: 'address2', required: false },
    { key: 'postal_code', required: true },
    { key: 'city', required: true },
    { key: 'country', required: true },
    { key: 'email', required: true },
    { key: 'phone', required: true }
  ];
  var EC_COUNTRIES = ['FR', 'BE', 'LU', 'MC'];

  /* Comptage par points de code (emoji / Unicode comptés comme l'affichage) */
  function codePointLength(v) {
    if (v === null || v === undefined) { return 0; }
    return Array.from(String(v)).length;
  }
  /* trim → null si vide (brouillon uniquement ; ne modifie jamais le champ) */
  function trimOrNull(v) {
    var t = String(v === null || v === undefined ? '' : v).trim();
    return t === '' ? null : t;
  }
  function looksLikeEmail(v) {
    var t = String(v === null || v === undefined ? '' : v).trim();
    return t.length > 0 && /.+@.+\..+/.test(t);
  }
  function phoneDigitCount(v) {
    var m = String(v === null || v === undefined ? '' : v).match(/\d/g);
    return m ? m.length : 0;
  }

  /* UUID v4 — crypto.randomUUID si dispo, sinon crypto.getRandomValues.
     Jamais Math.random (non cryptographique). Valeur éphémère (mémoire seule). */
  function uuidV4() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var b = new Uint8Array(16);
        window.crypto.getRandomValues(b);
        b[6] = (b[6] & 0x0f) | 0x40; // version 4
        b[8] = (b[8] & 0x3f) | 0x80; // variant 10xx
        var h = [];
        for (var i = 0; i < 256; i++) { h[i] = (i + 0x100).toString(16).slice(1); }
        return (h[b[0]] + h[b[1]] + h[b[2]] + h[b[3]] + '-' +
                h[b[4]] + h[b[5]] + '-' + h[b[6]] + h[b[7]] + '-' +
                h[b[8]] + h[b[9]] + '-' +
                h[b[10]] + h[b[11]] + h[b[12]] + h[b[13]] + h[b[14]] + h[b[15]]);
      }
    } catch (e) { /* ignore : retombe sur null ci-dessous */ }
    return null;
  }

  window.__pp = window.__pp || {
    instances: new Map(),
    uploadcarePromise: null,
    listenersBound: false
  };
  var PP = window.__pp;

  /* ---------- utils ---------- */
  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    return n;
  }
  function extOf(name) {
    if (!name || typeof name !== 'string') { return ''; }
    var i = name.lastIndexOf('.');
    return i >= 0 ? name.slice(i + 1).toLowerCase() : '';
  }
  function formatBytes(bytes) {
    if (typeof bytes !== 'number' || !isFinite(bytes) || bytes < 0) { return ''; }
    if (bytes < 1024) { return bytes + ' o'; }
    var kb = bytes / 1024;
    if (kb < 1024) { return (Math.round(kb * 10) / 10) + ' Ko'; }
    var mb = kb / 1024;
    return (Math.round(mb * 10) / 10) + ' Mo';
  }
  /* Contrat pp-draft-v3 : la disposition porte la composition ET les roles.
     Seule table de verite du frontend sur ce point ; toute lecture passe par
     rolesForLayout / compositionForLayout, jamais par une deduction locale.

       front_only  1 photo  role front       dos uni clair realise par l'atelier
       panoramic   1 photo  role panoramic   l'image fait le tour
       front_back  2 photos roles front+back une image par demi-cylindre

     Aucun fichier blanc n'est demande pour front_only : le dos n'est pas une
     photographie, il ne compte donc pas comme emplacement. */
  var LAYOUTS = {
    front_only: { composition: 1, roles: ['front'] },
    panoramic: { composition: 1, roles: ['panoramic'] },
    front_back: { composition: 2, roles: ['front', 'back'] }
  };
  function isLayout(v) {
    return typeof v === 'string' && Object.prototype.hasOwnProperty.call(LAYOUTS, v);
  }
  function rolesForLayout(layout) {
    return isLayout(layout) ? LAYOUTS[layout].roles.slice() : [];
  }
  function compositionForLayout(layout) {
    return isLayout(layout) ? LAYOUTS[layout].composition : null;
  }

  /* Repli pour les demandes anterieures a v3, ou le serveur ne renvoie pas de
     photo_layout : seule la composition etait connue. Conserve tel quel pour ne
     pas casser l'historique deja enregistre. */
  function rolesForMode(mode) {
    if (mode === 1) { return ['panoramic']; }
    if (mode === 2) { return ['front', 'back']; }
    return [];
  }

  /* ---------- chargement paresseux Uploadcare (une seule fois) ---------- */
  function loadUploadcare() {
    if (window.uploadcare && typeof window.uploadcare.openDialog === 'function') {
      return Promise.resolve(window.uploadcare);
    }
    if (PP.uploadcarePromise) { return PP.uploadcarePromise; }
    PP.uploadcarePromise = new Promise(function (resolve, reject) {
      try {
        window.UPLOADCARE_LOCALE = 'fr';
        window.UPLOADCARE_MANUAL_START = true;
        var existing = document.querySelector('script[data-pp-uploadcare-script]');
        if (existing) {
          existing.addEventListener('load', function () { resolve(window.uploadcare); });
          existing.addEventListener('error', function () { reject(new Error('uploadcare-load-failed')); });
          return;
        }
        var s = document.createElement('script');
        s.src = CDN;
        s.async = true;
        s.charset = 'utf-8';
        s.setAttribute('data-pp-uploadcare-script', '');
        s.onload = function () {
          if (window.uploadcare && typeof window.uploadcare.openDialog === 'function') {
            resolve(window.uploadcare);
          } else {
            reject(new Error('uploadcare-undefined'));
          }
        };
        s.onerror = function () { reject(new Error('uploadcare-load-failed')); };
        (document.head || document.documentElement).appendChild(s);
      } catch (e) { reject(e); }
    });
    return PP.uploadcarePromise;
  }

  /* ---------- Instance ---------- */
  function Instance(root) {
    this.root = root;
    this.designMode = root.getAttribute('data-pp-design-mode') === 'true';
    this.publicKey = root.getAttribute('data-pp-uploadcare-public-key') || '';
    this.maxFileBytes = parseInt(root.getAttribute('data-pp-max-file-bytes'), 10) || 26214400;
    this.maxTotalBytes = parseInt(root.getAttribute('data-pp-max-total-bytes'), 10) || 52428800;
    this.layout = null;          // front_only | panoramic | front_back
    this.pendingLayout = null;   // disposition visee, en attente de confirmation
    this.slots = {};

    this.slotsHost = root.querySelector('[data-pp-upload-slots]');
    this.emptyState = root.querySelector('[data-pp-upload-empty-state]');
    this.statusEl = root.querySelector('[data-pp-upload-status]');
    this.confirmEl = root.querySelector('[data-pp-mode-confirmation]');
    this.consentEl = root.querySelector('[data-pp-production-rights-consent]');
    this.layoutRadios = Array.prototype.slice.call(root.querySelectorAll('input[name="pp_photo_layout"]'));

    /* --- 12E-B : formulaire dynamique local (état miroir + brouillon) --- */
    this.form = root.querySelector('[data-pp-form]');
    this.formStatusEl = root.querySelector('[data-pp-form-status]');
    this.errorSummaryEl = root.querySelector('[data-pp-error-summary]');

    /* --- EXPRESS-7B : soumission contrôlée (POST réel) --- */
    this.submitBtn = root.querySelector('[data-pp-submit]');
    this.submitErrorEl = root.querySelector('[data-pp-submit-error]');
    this.successEl = root.querySelector('[data-pp-success]');
    this.footNoteEl = root.querySelector('[data-pp-form-foot-note]');
    this.submitBtnDefaultLabel = this.submitBtn ? this.submitBtn.textContent : 'Envoyer ma demande';
    /* État de soumission — jamais autoritaire côté métier (Laravel = source de vérité). */
    this.submitting = false;
    this.submitted = false;
    this.idempotencyKey = null;
    this.idempotencyPayloadSignature = null;
    /* Epoque du formulaire. Un televersement ouvert avant une remise a zero
       aboutit parfois apres : sa promesse Uploadcare vit sa vie et rien ne
       l'annule. Sans ce compteur, une photographie de la demande precedente
       viendrait se poser dans le formulaire vierge, sous un role qui ne lui
       appartient plus. Chaque travail asynchrone retient l'epoque de son
       lancement et abandonne si elle a change. */
    this.formEpoch = 0;
    this.initialSnapshot = null;
    /* Tentative dont l'issue est INCONNUE : la requete est partie, la reponse
       s'est perdue. Le serveur l'a peut-etre enregistree, peut-etre pas — une
       erreur reseau ne permet pas de trancher, et rien ici ne doit pretendre le
       contraire. Tant qu'elle n'est pas resolue, on retient sa cle ET son
       payload : { key, payload, signature }. */
    this.pendingAttempt = null;
    /* Tentative effectivement partie sur le reseau, quelle qu'en soit l'issue.
       Distincte de pendingAttempt : celle-ci n'est retenue qu'une fois l'issue
       devenue INCERTAINE. */
    this.currentAttempt = null;
    /* Formulaire verrouille : des le debut d'un envoi, et tant qu'une tentative
       incertaine n'est pas resolue. Ce qui est affiche doit alors correspondre
       exactement a ce qui a ete envoye — sans quoi le photographe croirait
       modifier une demande que la reprise renverra telle quelle. */
    this.locked = false;

    this.refInput = root.querySelector('input[name="pp_partner_internal_reference"]');
    this.textInput = root.querySelector('textarea[name="pp_text"]');
    this.instrInput = root.querySelector('textarea[name="pp_instructions"]');
    this.modeleRadios = Array.prototype.slice.call(root.querySelectorAll('input[name="pp_model_size"]'));
    /* Vue « modèle » — l'état de disponibilité vit ici, jamais dans une liste
       de tailles recopiée : les valeurs connues sont celles des boutons rendus
       par le Liquid, et leur ouverture vient de /me (model_sizes). L'état de
       départ est l'attente, pas l'ouverture : tant que le serveur n'a pas
       répondu, aucun modèle n'est sélectionnable. */
    this.modeleVue = this.modeleRadios.length ? {
      radios: this.modeleRadios,
      labels: {},
      statuts: {},
      fieldset: root.querySelector('[data-pp-modele]'),
      errorEl: root.querySelector('[data-pp-modele-error]'),
      etat: 'loading',
      sizes: null,
      avis: ''
    } : null;
    if (this.modeleVue) {
      for (var mv = 0; mv < this.modeleRadios.length; mv++) {
        var mval = this.modeleRadios[mv].value;
        this.modeleVue.labels[mval] = root.querySelector('[data-pp-modele-choix="' + mval + '"]');
        this.modeleVue.statuts[mval] = root.querySelector('[data-pp-modele-statut="' + mval + '"]');
      }
    }
    this.socleRadios = Array.prototype.slice.call(root.querySelectorAll('input[name="pp_couleur_socle"]'));
    this.shippingRadios = Array.prototype.slice.call(root.querySelectorAll('input[name="pp_shipping_destination"]'));
    this.contentReuseEl = root.querySelector('[data-pp-content-reuse-consent]');
    this.quantiteInput = root.querySelector('input[name="pp_quantity"]');
    this.quantiteErrorEl = root.querySelector('[data-pp-quantite-error]');
    this.recapEl = root.querySelector('[data-pp-recap]');

    this.ecFieldset = root.querySelector('[data-pp-end-customer]');
    this.destConfirmEl = root.querySelector('[data-pp-destination-confirmation]');
    this.pendingShippingMode = null;

    /* Champs client final indexés par clé + zones d'erreur associées */
    this.ecInputs = {};
    this.ecErrors = {};
    var ecNodes = root.querySelectorAll('[data-pp-ec-field]');
    for (var e = 0; e < ecNodes.length; e++) {
      this.ecInputs[ecNodes[e].getAttribute('data-pp-ec-field')] = ecNodes[e];
    }
    var errNodes = root.querySelectorAll('[data-pp-field-error-for]');
    for (var f = 0; f < errNodes.length; f++) {
      this.ecErrors[errNodes[f].getAttribute('data-pp-field-error-for')] = errNodes[f];
    }

    /* Compteurs de caractères indexés par clé */
    this.counters = {};
    var cNodes = root.querySelectorAll('[data-pp-counter]');
    for (var c = 0; c < cNodes.length; c++) {
      var key = cNodes[c].getAttribute('data-pp-counter-for');
      var conf = COUNTER_CONF[key];
      if (!conf) { continue; }
      this.counters[key] = {
        el: cNodes[c],
        input: root.querySelector('[name="' + conf.name + '"]'),
        max: conf.max,
        threshold: conf.threshold
      };
    }

    /* Miroir normalisé — jamais une seconde source de vérité (le DOM prime) */
    this.formState = {
      partnerInternalReference: '',
      text: '',
      instructions: '',
      baseColor: null,
      shippingMode: null,
      endCustomer: null,
      productionRightsConsent: false,
      contentReuseConsent: false,
      touched: new Set()
    };
  }

  Instance.prototype.status = function (msg) {
    if (this.statusEl) { this.statusEl.textContent = msg || ''; }
  };

  Instance.prototype.consentGiven = function () {
    return !!(this.consentEl && this.consentEl.checked);
  };

  Instance.prototype.hasAnyFile = function () {
    var r, roles = rolesForLayout(this.layout);
    for (var i = 0; i < roles.length; i++) {
      r = this.slots[roles[i]];
      if (r && r.state === 'ready') { return true; }
    }
    return false;
  };

  Instance.prototype.totalBytesExcept = function (exceptRole) {
    var total = 0, role, s, roles = rolesForLayout(this.layout);
    for (var i = 0; i < roles.length; i++) {
      role = roles[i];
      if (role === exceptRole) { continue; }
      s = this.slots[role];
      if (s && s.state === 'ready' && typeof s.size === 'number') { total += s.size; }
    }
    return total;
  };

  /* ---------- rendu des emplacements ---------- */
  Instance.prototype.renderSlots = function () {
    if (!this.slotsHost) { return; }
    this.slotsHost.innerHTML = '';
    var roles = rolesForLayout(this.layout);
    if (this.emptyState) { this.emptyState.hidden = roles.length > 0; }

    for (var i = 0; i < roles.length; i++) {
      this.slotsHost.appendChild(this.buildSlot(roles[i]));
    }
  };

  Instance.prototype.buildSlot = function (role) {
    var self = this;
    var wrap = el('div', 'pp__upload-slot');
    wrap.setAttribute('data-pp-upload-slot', '');
    wrap.setAttribute('data-pp-upload-role', role);
    wrap.setAttribute('data-pp-upload-state', 'empty');

    var head = el('p', 'pp__upload-slot-role');
    head.textContent = ROLE_LABEL[role];
    wrap.appendChild(head);

    var hint = el('p', 'pp__upload-slot-hint');
    hint.textContent = ROLE_HINT[role];
    wrap.appendChild(hint);

    /* Formats et poids acceptés, dans le cadre de la photographie — c'est là que
       la question se pose, au moment de choisir un fichier. La limite est reprise
       de la valeur réellement appliquée (data-pp-max-file-bytes) plutôt que
       recopiée : le texte affiché ne peut donc pas diverger du contrôle. */
    var specs = el('p', 'pp__upload-slot-specs');
    specs.textContent = 'JPG, PNG ou WEBP · ' + formatBytes(this.maxFileBytes) + ' maximum';
    wrap.appendChild(specs);

    var body = el('div', 'pp__upload-slot-body');
    wrap.appendChild(body);

    var slot = this.slots[role] || { role: role, state: 'empty' };
    this.slots[role] = slot;
    slot.wrap = wrap;
    slot.body = body;

    // Bouton "Ajouter"
    var addBtn = el('button', 'pp__button pp__button--upload');
    addBtn.type = 'button';
    addBtn.setAttribute('data-pp-upload-add', '');
    addBtn.textContent = 'Ajouter la photographie';
    addBtn.addEventListener('click', function () { self.onAdd(role); });
    slot.addBtn = addBtn;

    this.paintSlot(role);
    this.refreshConsentGate();
    return wrap;
  };

  Instance.prototype.paintSlot = function (role) {
    var slot = this.slots[role];
    if (!slot || !slot.body) { return; }
    var body = slot.body;
    body.innerHTML = '';
    slot.wrap.setAttribute('data-pp-upload-state', slot.state);

    /* Verrou pose : aucune action sur les photographies. Les vignettes restent
       visibles — il faut bien voir ce qui a ete envoye — mais rien ne permet
       d'ajouter, de remplacer ni de supprimer. */
    if (slot.state === 'empty') {
      if (!this.locked) { body.appendChild(slot.addBtn); }
      return;
    }
    if (slot.state === 'opening' || slot.state === 'loading' || slot.state === 'processing') {
      var loading = el('p', 'pp__upload-loading');
      loading.setAttribute('aria-live', 'polite');
      loading.textContent = slot.state === 'processing'
        ? 'Traitement de la photographie…'
        : 'Téléversement en cours…';
      body.appendChild(loading);
      return;
    }
    if (slot.state === 'error') {
      var err = el('p', 'pp__upload-error');
      err.textContent = slot.error || 'Impossible d’ajouter cette photographie. Réessayez.';
      body.appendChild(err);
      var retry = el('button', 'pp__button pp__button--upload');
      retry.type = 'button';
      retry.textContent = 'Réessayer';
      var self = this;
      retry.addEventListener('click', function () { self.onAdd(role); });
      body.appendChild(retry);
      return;
    }
    if (slot.state === 'ready') {
      var fig = el('div', 'pp__upload-preview');
      if (slot.cdnUrl) {
        var img = el('img', 'pp__upload-preview-img');
        img.src = slot.cdnUrl + '-/preview/240x240/-/quality/smart/';
        img.alt = ROLE_ALT[role];
        img.loading = 'lazy';
        img.width = 120;
        img.height = 120;
        fig.appendChild(img);
      }
      body.appendChild(fig);

      var meta = el('div', 'pp__upload-meta');
      if (slot.name) {
        var nm = el('p', 'pp__upload-name');
        nm.textContent = slot.name;
        meta.appendChild(nm);
      }
      var line = el('p', 'pp__upload-metaline');
      var parts = [];
      if (typeof slot.size === 'number') { parts.push(formatBytes(slot.size)); }
      if (typeof slot.width === 'number' && typeof slot.height === 'number' &&
          slot.width > 0 && slot.height > 0) {
        parts.push(slot.width + ' × ' + slot.height + ' px');
      }
      line.textContent = parts.join(' · ');
      if (parts.length) { meta.appendChild(line); }
      body.appendChild(meta);

      if (slot.warnings && slot.warnings.length) {
        var wl = el('ul', 'pp__upload-warnings');
        for (var w = 0; w < slot.warnings.length; w++) {
          var li = el('li', 'pp__upload-warning');
          li.textContent = slot.warnings[w];
          wl.appendChild(li);
        }
        body.appendChild(wl);
      }

      if (this.locked) { return; }

      var actions = el('div', 'pp__upload-actions');
      var self2 = this;
      var repl = el('button', 'pp__button pp__button--ghost');
      repl.type = 'button';
      repl.textContent = 'Remplacer';
      repl.addEventListener('click', function () { self2.onAdd(role); });
      var del = el('button', 'pp__button pp__button--danger');
      del.type = 'button';
      del.textContent = 'Supprimer';
      del.addEventListener('click', function () { self2.onDelete(role); });
      actions.appendChild(repl);
      actions.appendChild(del);
      body.appendChild(actions);
      return;
    }
  };

  /* ---------- gate consentement ---------- */
  Instance.prototype.refreshConsentGate = function () {
    var enabled = this.consentGiven();
    var roles = rolesForLayout(this.layout);
    for (var i = 0; i < roles.length; i++) {
      var slot = this.slots[roles[i]];
      if (slot && slot.addBtn) {
        var blocked = !enabled;
        slot.addBtn.disabled = blocked;
        slot.addBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      }
    }
  };

  /* ---------- ajout / ouverture ---------- */
  Instance.prototype.onAdd = function (role) {
    // Envoi en cours ou tentative incertaine : les photographies sont figees.
    if (this.locked) { return; }
    // Consentement obligatoire
    if (!this.consentGiven()) {
      this.status('Confirmez l’autorisation de traitement pour ajouter les photographies.');
      if (this.consentEl && typeof this.consentEl.focus === 'function') { this.consentEl.focus(); }
      return;
    }
    // Éditeur : aucun réseau, aucun dialogue réel
    if (this.designMode) {
      this.status('Aperçu éditeur — ajout de photographies désactivé.');
      return;
    }
    // Absence de clé publique : service indisponible
    if (!this.publicKey) {
      this.status('Service d’ajout de photographies temporairement indisponible.');
      return;
    }

    var self = this;
    var slot = this.slots[role];
    slot.state = 'opening';
    this.paintSlot(role);
    this.status('Ouverture du sélecteur…');

    /* Époque au moment de l'ouverture : tout ce qui revient après une remise à
       zéro se rapporte à une demande déjà partie et doit être ignoré. */
    var epoch = this.formEpoch;
    var perime = function () { return self.formEpoch !== epoch; };

    loadUploadcare().then(function (uc) {
      if (perime()) { return; }
      var maxBytes = self.maxFileBytes;
      var settings = {
        publicKey: self.publicKey,
        imagesOnly: true,
        locale: 'fr',
        clearable: false,
        multiple: false,
        validators: [function (fileInfo) {
          if (fileInfo && fileInfo.size !== null && typeof fileInfo.size === 'number' &&
              fileInfo.size > maxBytes) {
            throw new Error('fileMaximumSize');
          }
        }]
      };
      var dialog = uc.openDialog(null, settings);
      dialog.done(function (fileObj) {
        if (perime()) { return; }
        slot.state = 'loading';
        self.paintSlot(role);
        self.status('Téléversement en cours…');
        fileObj.promise().then(function (info) {
          if (perime()) { return; }
          slot.state = 'processing';
          self.paintSlot(role);
          self.applyReady(role, info);
        }).catch(function () {
          if (perime()) { return; }
          self.setError(role, 'Impossible d’ajouter cette photographie. Réessayez.');
        });
      });
      if (typeof dialog.fail === 'function') {
        dialog.fail(function () {
          // Annulation ou échec du dialogue : revenir à l'état précédent sans erreur trompeuse
          if (slot.state === 'opening') {
            slot.state = slot.cdnUrl ? 'ready' : 'empty';
            self.paintSlot(role);
            self.status('');
          }
        });
      }
    }).catch(function () {
      self.setError(role, 'Service d’ajout indisponible pour le moment. Réessayez.');
    });
  };

  Instance.prototype.setError = function (role, msg) {
    var slot = this.slots[role];
    slot.state = 'error';
    slot.error = msg;
    this.paintSlot(role);
    this.status(msg);
    this.refreshConsentGate();
    this.updateSubmitButtonState();
  };

  /* ---------- validation + application d'un fichier prêt ---------- */
  Instance.prototype.applyReady = function (role, info) {
    var name = info && info.name ? String(info.name) : '';
    var size = info && typeof info.size === 'number' ? info.size : null;

    // Type
    var ext = extOf(name);
    if (ext && ALLOWED_EXT.indexOf(ext) === -1) {
      this.setError(role, 'Format non accepté. Utilisez JPG, JPEG, PNG ou WEBP.');
      return;
    }
    // Taille par fichier
    if (size !== null && size > this.maxFileBytes) {
      this.setError(role, 'Le fichier dépasse la limite de ' + formatBytes(this.maxFileBytes) + '.');
      return;
    }
    // Taille totale (en tenant compte d'un remplacement du même emplacement)
    if (size !== null) {
      var projected = this.totalBytesExcept(role) + size;
      if (projected > this.maxTotalBytes) {
        this.setError(role, 'L’ensemble des photographies dépasse la limite de ' + formatBytes(this.maxTotalBytes) + '.');
        return;
      }
    }

    // Dimensions uniquement si réellement fournies
    var width = null, height = null;
    if (info && info.originalImageInfo &&
        typeof info.originalImageInfo.width === 'number' && info.originalImageInfo.width > 0 &&
        typeof info.originalImageInfo.height === 'number' && info.originalImageInfo.height > 0) {
      width = info.originalImageInfo.width;
      height = info.originalImageInfo.height;
    }

    var warnings = this.computeWarnings(role, width, height);

    // Remplacement validé uniquement après succès du nouveau fichier
    this.slots[role] = {
      role: role,
      uuid: info && info.uuid ? info.uuid : null,
      cdnUrl: info && info.cdnUrl ? info.cdnUrl : null,
      name: name,
      size: size,
      width: width,
      height: height,
      warnings: warnings,
      state: 'ready',
      wrap: this.slots[role].wrap,
      body: this.slots[role].body,
      addBtn: this.slots[role].addBtn
    };
    this.paintSlot(role);
    this.status('Photographie ajoutée.');
    this.refreshConsentGate();
    this.updateSubmitButtonState();
  };

  Instance.prototype.computeWarnings = function (role, width, height) {
    var warnings = [];
    if (width === null || height === null) { return warnings; }
    var target = TARGET[role];
    if (!target) { return warnings; }

    /* L'avertissement de définition a été retiré le 2026-09-09.

       Il comparait chaque fichier a 4080 x 2100 px, un seuil unique herite de
       l'epoque ou la boutique ne proposait qu'une taille de lampe. Depuis
       l'ajout du choix de modele, ce nombre ne veut plus rien dire : il
       alarmait sur une image parfaitement exploitable pour une petite lampe.
       Le formulaire ne promet d'ailleurs plus aucune dimension.

       Aucun seuil par taille ne le remplace : nous n'en avons pas de valide, et
       en inventer un reproduirait la meme faute a trois exemplaires. La
       definition est desormais examinee par l'atelier, qui recontacte le
       partenaire si un autre fichier est necessaire -- exactement ce que la
       consigne de televersement annonce.

       Ce qui reste en place, inchange : format de fichier accepte, poids
       maximum, lisibilite du fichier, et l'avertissement de cadrage ci-dessous,
       qui porte sur une proportion vraie pour les trois tailles. */

    var targetRatio = target.w / target.h;
    var ratio = width / height;
    var diff = Math.abs(ratio - targetRatio) / targetRatio;
    if (diff > RATIO_TOLERANCE) {
      warnings.push('Le cadrage diffère des proportions recommandées. L’atelier pourra vous recontacter.');
    }
    // pas plus de deux avertissements identiques (dédoublonnage simple)
    var seen = {}, out = [];
    for (var i = 0; i < warnings.length; i++) {
      if (!seen[warnings[i]]) { seen[warnings[i]] = true; out.push(warnings[i]); }
    }
    return out;
  };

  /* ---------- suppression ---------- */
  Instance.prototype.onDelete = function (role) {
    if (this.locked) { return; }
    var slot = this.slots[role];
    if (!slot) { return; }
    this.slots[role] = { role: role, state: 'empty', wrap: slot.wrap, body: slot.body, addBtn: slot.addBtn };
    this.paintSlot(role);
    this.status('Photographie supprimée.');
    this.refreshConsentGate();
    this.updateSubmitButtonState();
    if (slot.addBtn && typeof slot.addBtn.focus === 'function') { slot.addBtn.focus(); }
  };

  /* ---------- changement de disposition ---------- */
  /* Retourne la disposition cochee, ou null si aucune ne l'est. Aucune case
     n'etant prechoisie, null est l'etat initial normal, pas une anomalie. */
  Instance.prototype.currentRadioMode = function () {
    for (var i = 0; i < this.layoutRadios.length; i++) {
      if (this.layoutRadios[i].checked) { return this.layoutRadios[i].value; }
    }
    return null;
  };

  Instance.prototype.setRadioTo = function (layout) {
    for (var i = 0; i < this.layoutRadios.length; i++) {
      this.layoutRadios[i].checked = (this.layoutRadios[i].value === layout);
    }
  };

  Instance.prototype.onCompositionChange = function () {
    var next = this.currentRadioMode();
    if (next === this.layout) { return; }
    if (!this.hasAnyFile()) {
      this.applyMode(next);
      return;
    }
    /* Fichiers presents : ne rien changer en silence.

       Le risque n'est pas seulement d'en perdre un, c'est d'en envoyer un sous
       un role qui n'est plus le sien. front_only et front_back partagent le
       role front : sans cette garde, une image deposee comme face avant d'un
       diptyque partirait telle quelle en vue de face unique, et inversement.
       On restaure donc la disposition courante et on demande confirmation ;
       applyMode vide ensuite tous les emplacements. */
    this.pendingLayout = next;
    this.setRadioTo(this.layout);
    this.showModeConfirm();
  };

  Instance.prototype.showModeConfirm = function () {
    if (!this.confirmEl) { return; }
    this.confirmEl.hidden = false;
    var confirmBtn = this.confirmEl.querySelector('[data-pp-mode-confirm]');
    if (confirmBtn && typeof confirmBtn.focus === 'function') { confirmBtn.focus(); }
  };

  Instance.prototype.hideModeConfirm = function () {
    if (this.confirmEl) { this.confirmEl.hidden = true; }
  };

  Instance.prototype.confirmModeChange = function () {
    var target = this.pendingLayout;
    this.clearAllSlots();
    this.hideModeConfirm();
    this.applyMode(target);
    this.setRadioTo(target);
    this.status('Disposition mise à jour. Les photographies précédentes ont été supprimées.');
  };

  Instance.prototype.cancelModeChange = function () {
    this.pendingLayout = null;
    this.hideModeConfirm();
    this.setRadioTo(this.layout);
    this.status('');
    for (var i = 0; i < this.layoutRadios.length; i++) {
      if (this.layoutRadios[i].value === this.layout) {
        if (typeof this.layoutRadios[i].focus === 'function') { this.layoutRadios[i].focus(); }
        break;
      }
    }
  };

  Instance.prototype.clearAllSlots = function () {
    this.slots = {};
  };

  Instance.prototype.applyMode = function (layout) {
    this.layout = isLayout(layout) ? layout : null;
    this.pendingLayout = null;
    /* Table des emplacements remise a zero, sans exception : c'est ce qui
       garantit qu'aucun fichier deja depose ne survit a un changement de
       disposition, meme lorsque l'ancien et le nouveau role portent le meme
       nom (front_only <-> front_back). */
    this.slots = {};
    this.renderSlots();
    this.updateSubmitButtonState();
  };

  /* ---------- consentement : empêcher le décochage si fichier prêt ---------- */
  Instance.prototype.onConsentChange = function () {
    if (!this.consentEl) { return; }
    if (!this.consentEl.checked && this.hasAnyFile()) {
      this.consentEl.checked = true;
      this.status('Supprimez les photographies ajoutées avant de retirer cette autorisation.');
      return;
    }
    this.refreshConsentGate();
    if (this.consentGiven()) { this.status(''); }
  };

  /* ============================================================
     12E-B — Formulaire dynamique local (compteurs, adresse, brouillon)
     ============================================================ */

  /* ---------- statut accessible du formulaire (distinct du statut upload) ---------- */
  Instance.prototype.formStatus = function (msg) {
    if (this.formStatusEl) { this.formStatusEl.textContent = msg || ''; }
  };

  /* ---------- compteurs de caractères ---------- */
  Instance.prototype.updateCounter = function (key) {
    var c = this.counters[key];
    if (!c || !c.el) { return; }
    var val = c.input ? c.input.value : '';
    var len = codePointLength(val);
    c.el.textContent = len + ' / ' + c.max;
    c.el.setAttribute('aria-label', len + ' caractères sur ' + c.max);
    c.el.classList.toggle('pp__counter--warning', len >= c.threshold);
  };
  Instance.prototype.updateAllCounters = function () {
    for (var key in this.counters) {
      if (Object.prototype.hasOwnProperty.call(this.counters, key)) { this.updateCounter(key); }
    }
  };

  /* ============================================================
     DISPONIBILITÉ DES MODÈLES — pilotée par le serveur

     L'ERP décide quelles tailles de lampe sont ouvertes à la commande et le
     dit dans la réponse de /me, sous model_sizes. Le thème n'en tient AUCUNE
     seconde liste : la liste des tailles offertes est celle des boutons déjà
     rendus par le Liquid, et leur ouverture vient entièrement du serveur.
     Rouvrir une taille est donc un réglage ERP, sans reprise du thème.

     Trois états, et un seul ouvre quoi que ce soit :
       loading — la réponse n'est pas arrivée. Rien n'est sélectionnable, rien
                 n'est annoncé indisponible : on ne sait pas encore.
       error   — réponse absente, illisible ou incomplète. Panne technique,
                 pas fermeture commerciale : on le dit comme tel et on bloque.
       ready   — model_sizes lu et complet. Les tailles fermées portent la
                 mention, les ouvertes redeviennent sélectionnables.

     Le navigateur n'est jamais autoritaire : Laravel refuse de lui-même une
     taille fermée. Ce qui suit évite au partenaire de composer une demande
     vouée au refus — cela ne remplace pas le contrôle serveur.
     ============================================================ */
  var MODELE_MENTION_FERME = 'Bientôt disponible';
  var MODELE_MSG_ATTENTE = 'Vérification des modèles disponibles…';
  var MODELE_MSG_ERREUR = 'Les modèles disponibles n’ont pas pu être vérifiés. ' +
    'Rechargez la page pour réessayer.';
  var MODELE_MSG_RETIRE = 'Le modèle choisi n’est plus disponible. ' +
    'Choisissez un modèle disponible pour poursuivre.';

  /* Lecture STRICTE de model_sizes.

     `connues` est la liste des tailles réellement offertes par le formulaire,
     relevée sur les boutons : elle n'est écrite nulle part ici. Chacune doit
     recevoir un booléen explicite. Une clé manquante, un « true » en chaîne,
     un null : la réponse est jugée illisible et renvoie null, ce qui conduit à
     l'état error. Deviner reviendrait soit à ouvrir une taille que le serveur
     refusera, soit à annoncer une indisponibilité commerciale inventée.

     Les clés supplémentaires sont ignorées : le jour où l'ERP en ajoute une,
     le thème ne s'y casse pas, il ne l'affiche simplement pas. */
  function lireModelSizes(brut, connues) {
    if (!brut || typeof brut !== 'object') { return null; }
    if (Object.prototype.toString.call(brut) === '[object Array]') { return null; }
    if (!connues || !connues.length) { return null; }
    var out = {};
    for (var i = 0; i < connues.length; i++) {
      var v = brut[connues[i]];
      if (typeof v !== 'boolean') { return null; }
      out[connues[i]] = v;
    }
    return out;
  }

  /* Rendu de la disponibilité sur une « vue modèle » :
       { radios, labels, statuts, fieldset, errorEl, etat, sizes, avis }

     Idempotent et intégralement recalculé à chaque passage : c'est ce qui
     permet de le rejouer après un déverrouillage, une remise à zéro ou une
     restauration d'onglet sans qu'un contrôle désactivé ne revienne à la vie.

     Renvoie la taille retirée d'office, s'il y en a une. */
  function rendreDisponibiliteModeles(vue) {
    if (!vue || !vue.radios) { return null; }
    var pret = vue.etat === 'ready';
    var retire = null;
    for (var i = 0; i < vue.radios.length; i++) {
      var radio = vue.radios[i];
      var valeur = radio.value;
      var ouvert = pret && vue.sizes ? vue.sizes[valeur] === true : false;

      /* disabled, et rien d'autre : le contrôle sort du parcours de
         tabulation, ne répond ni au clic, ni à Espace, ni aux flèches du
         groupe de boutons radio. Une mise en gris CSS ou un pointer-events
         laisserait le clavier passer outre. */
      radio.disabled = !ouvert;
      radio.setAttribute('aria-disabled', ouvert ? 'false' : 'true');

      /* Une taille CONFIRMÉE fermée ne peut pas rester cochée : c'est le cas
         d'un formulaire laissé ouvert, ou rouvert par le navigateur avec ses
         cases d'avant. On la décoche sans rien reporter ailleurs — convertir
         en silence une commande de petit modèle en grand modèle serait
         changer la commande à la place du partenaire.

         Pendant l'attente et après un échec, en revanche, on ne touche à
         rien : l'envoi est bloqué par ailleurs, et effacer un choix sur une
         panne réseau ferait perdre une saisie pour rien. */
      if (pret && radio.checked && !ouvert) {
        radio.checked = false;
        retire = valeur;
      }

      var etat = pret ? (ouvert ? 'ouvert' : 'ferme') : 'attente';
      var label = vue.labels ? vue.labels[valeur] : null;
      if (label) { label.setAttribute('data-pp-modele-etat', etat); }

      /* La mention n'apparaît que sur une fermeture dite par le serveur.
         L'afficher pendant l'attente ou sur une panne annoncerait une
         indisponibilité commerciale que personne n'a constatée. */
      var statut = vue.statuts ? vue.statuts[valeur] : null;
      if (statut) {
        var ferme = pret && !ouvert;
        statut.textContent = ferme ? MODELE_MENTION_FERME : '';
        statut.hidden = !ferme;
      }
    }

    if (retire) { vue.avis = MODELE_MSG_RETIRE; }
    if (vue.fieldset) {
      vue.fieldset.setAttribute('data-pp-modele-disponibilite', vue.etat);
    }

    var message = '';
    if (vue.etat === 'loading') { message = MODELE_MSG_ATTENTE; }
    else if (vue.etat === 'error') { message = MODELE_MSG_ERREUR; }
    else { message = vue.avis || ''; }
    if (vue.errorEl) {
      vue.errorEl.textContent = message;
      vue.errorEl.hidden = !message;
    }
    return retire;
  }

  /* ---------- disponibilité des modèles : état porté par l'instance ---------- */

  /* Nouvel état reçu du serveur. Appelé à chaque réponse /me exploitable :
     une taille rouverte côté ERP redevient sélectionnable et perd sa mention
     au prochain chargement, sans autre réglage ici. */
  Instance.prototype.setModelAvailability = function (brut) {
    var vue = this.modeleVue;
    if (!vue) { return; }
    var connues = [];
    for (var i = 0; i < vue.radios.length; i++) { connues.push(vue.radios[i].value); }
    var sizes = lireModelSizes(brut, connues);
    if (sizes === null) { this.setModelAvailabilityError(); return; }
    vue.etat = 'ready';
    vue.sizes = sizes;
    rendreDisponibiliteModeles(vue);
    this.updateRecap();
    this.updateSubmitButtonState();
  };

  /* Réponse absente, illisible ou incomplète. On ne rouvre rien par défaut et
     on n'annonce aucune indisponibilité commerciale : le message dit une
     vérification impossible, et l'envoi reste bloqué. */
  Instance.prototype.setModelAvailabilityError = function () {
    var vue = this.modeleVue;
    if (!vue) { return; }
    vue.etat = 'error';
    vue.sizes = null;
    vue.avis = '';
    rendreDisponibiliteModeles(vue);
    this.updateRecap();
    this.updateSubmitButtonState();
  };

  /* Réaffirmation de l'état connu.

     Plusieurs mécanismes reposent les attributs des champs après coup : le
     déverrouillage du formulaire, la remise à zéro d'après succès, et surtout
     la restauration d'un onglet par le navigateur, qui restitue les cases
     cochées et les contrôles actifs tels qu'ils étaient. Chacun de ces
     passages doit se conclure ici, sinon une taille fermée redeviendrait
     cliquable. Aucun appel réseau : on rejoue ce que le serveur a déjà dit,
     et c'est lui qui reste la protection d'un onglet resté ouvert. */
  Instance.prototype.reassertModelAvailability = function () {
    if (!this.modeleVue) { return; }
    rendreDisponibiliteModeles(this.modeleVue);
    this.updateRecap();
    this.updateSubmitButtonState();
  };

  Instance.prototype.modelAvailabilityReady = function () {
    return !!(this.modeleVue && this.modeleVue.etat === 'ready');
  };

  /* Une taille est ouverte seulement si le serveur l'a dite ouverte. En
     l'absence de bloc modèle (aperçu isolé sans ce champ), on ne bloque pas
     sur une contrainte qui n'existe pas. */
  Instance.prototype.modelSizeOpen = function (taille) {
    var vue = this.modeleVue;
    if (!vue) { return true; }
    if (vue.etat !== 'ready' || !vue.sizes) { return false; }
    return vue.sizes[taille] === true;
  };

  /* ---------- lectures ponctuelles ---------- */
  Instance.prototype.currentModele = function () {
    for (var i = 0; i < this.modeleRadios.length; i++) {
      if (this.modeleRadios[i].checked) { return this.modeleRadios[i].value; }
    }
    return null;
  };
  /* Quantite courante, ou null si la saisie n'est pas exploitable. */
  Instance.prototype.currentQuantite = function () {
    if (!this.quantiteInput) { return QUANTITE_MIN; }
    return lireQuantite(this.quantiteInput.value);
  };

  /* Prix unitaires du modele choisi, HT et TTC, plus le nom du modele.

     Rien n'est recopie ici : tout est lu sur la ligne de tarif deja affichee,
     seule ecriture des montants dans le theme. Le nom du modele est pris sur
     la meme ligne (.pp__tarifs-modele) plutot que redeclare cote script : le
     tableau reste l'unique endroit ou « Petit modele » est ecrit.

     Renvoie null tant qu'aucun modele n'est choisi, ou si l'un des deux
     attributs manque — un total a moitie calcule vaut moins que pas de total. */
  Instance.prototype.prixUnitaires = function () {
    var taille = this.currentModele();
    if (!taille) { return null; }
    var ligne = this.root.querySelector('[data-pp-tarif="' + taille + '"]');
    if (!ligne) { return null; }
    var ht = parseFloat(ligne.getAttribute('data-pp-tarif-ht'));
    var ttc = parseFloat(ligne.getAttribute('data-pp-tarif-ttc'));
    if (!isFinite(ht) || !isFinite(ttc)) { return null; }
    var nomEl = ligne.querySelector('.pp__tarifs-modele');
    var nom = nomEl ? String(nomEl.textContent).trim() : '';
    return { ht: ht, ttc: ttc, nom: nom };
  };

  /* « Total pour cette commande ». Affichage seul : aucun de ces montants
     n'entre dans le payload, et aucune remise de volume n'est appliquee — le
     prix unitaire ne depend pas du nombre d'exemplaires.

     Appele a chaque changement de modele et a chaque frappe sur la quantite :
     les deux ecouteurs sont poses dans init(). Tant que l'un des deux manque,
     le bloc reste masque plutot que d'afficher un total partiel. */
  Instance.prototype.updateRecap = function () {
    if (!this.recapEl) { return; }
    var pu = this.prixUnitaires();
    var q = this.currentQuantite();
    if (pu === null || q === null) { this.recapEl.hidden = true; return; }
    var totaux = totauxCommande(pu.ht, pu.ttc, q);
    var m = this.recapEl.querySelector('[data-pp-recap-modele]');
    var n = this.recapEl.querySelector('[data-pp-recap-quantite]');
    var ht = this.recapEl.querySelector('[data-pp-recap-total-ht]');
    var ttc = this.recapEl.querySelector('[data-pp-recap-total-ttc]');
    if (m) { m.textContent = pu.nom; }
    if (n) { n.textContent = String(q); }
    if (ht) { ht.textContent = formatEuros(totaux.ht); }
    if (ttc) { ttc.textContent = formatEuros(totaux.ttc); }
    this.recapEl.hidden = false;
  };

  /* Message de guidage sous le champ. Immediat, jamais bloquant en soi : il
     accompagne la saisie, la validation d'envoi fait foi. */
  Instance.prototype.updateQuantiteError = function () {
    if (!this.quantiteErrorEl) { return; }
    var brut = this.quantiteInput ? this.quantiteInput.value : '';
    if (String(brut).trim() === '') {
      this.quantiteErrorEl.textContent = 'Indiquez un nombre d\u2019exemplaires.';
      this.quantiteErrorEl.hidden = false;
      return;
    }
    if (this.currentQuantite() === null) {
      this.quantiteErrorEl.textContent =
        'Nombre d\u2019exemplaires invalide : un entier de ' + QUANTITE_MIN + ' \u00e0 ' + QUANTITE_MAX + '.';
      this.quantiteErrorEl.hidden = false;
      return;
    }
    this.quantiteErrorEl.textContent = '';
    this.quantiteErrorEl.hidden = true;
  };

  Instance.prototype.currentSocle = function () {
    for (var i = 0; i < this.socleRadios.length; i++) {
      if (this.socleRadios[i].checked) { return this.socleRadios[i].value; }
    }
    return null;
  };
  Instance.prototype.selectedShipping = function () {
    for (var i = 0; i < this.shippingRadios.length; i++) {
      if (this.shippingRadios[i].checked) { return this.shippingRadios[i].value; }
    }
    return null;
  };
  Instance.prototype.setShippingTo = function (value) {
    for (var i = 0; i < this.shippingRadios.length; i++) {
      this.shippingRadios[i].checked = (this.shippingRadios[i].value === value);
    }
  };
  Instance.prototype.focusShipping = function (value) {
    for (var i = 0; i < this.shippingRadios.length; i++) {
      if (this.shippingRadios[i].value === value &&
          typeof this.shippingRadios[i].focus === 'function') {
        this.shippingRadios[i].focus();
        return;
      }
    }
  };

  /* ---------- client final : présence de données saisies ---------- */
  Instance.prototype.endCustomerHasData = function () {
    for (var i = 0; i < EC_FIELDS.length; i++) {
      var input = this.ecInputs[EC_FIELDS[i].key];
      if (input && String(input.value).trim() !== '') { return true; }
    }
    return false;
  };

  /* ---------- affichage / masquage du bloc client final ---------- */
  Instance.prototype.showEndCustomer = function (focusFirst) {
    if (!this.ecFieldset) { return; }
    this.ecFieldset.disabled = false;
    this.ecFieldset.hidden = false;
    for (var i = 0; i < EC_FIELDS.length; i++) {
      var input = this.ecInputs[EC_FIELDS[i].key];
      if (!input) { continue; }
      if (EC_FIELDS[i].required) {
        input.required = true;
        input.setAttribute('aria-required', 'true');
      }
    }
    this.syncEndCustomerState();
    this.formStatus('Les coordonnées du client final sont maintenant disponibles.');
    if (focusFirst) {
      var first = this.ecInputs.first_name;
      if (first && typeof first.focus === 'function') { first.focus(); }
    }
  };

  Instance.prototype.purgeEndCustomer = function () {
    for (var i = 0; i < EC_FIELDS.length; i++) {
      var key = EC_FIELDS[i].key;
      var input = this.ecInputs[key];
      if (input) {
        if (input.tagName === 'SELECT') { input.selectedIndex = 0; } else { input.value = ''; }
        input.required = false;
        input.removeAttribute('aria-required');
        input.removeAttribute('aria-invalid');
        input.classList.remove('pp__input--invalid');
      }
      this.showFieldError(key, null);
      this.formState.touched.delete(key);
    }
    if (this.ecFieldset) {
      this.ecFieldset.hidden = true;
      this.ecFieldset.disabled = true;
    }
    this.formState.endCustomer = null;
    if (this.errorSummaryEl) { this.errorSummaryEl.hidden = true; this.errorSummaryEl.innerHTML = ''; }
  };

  /* ---------- changement de destination ---------- */
  Instance.prototype.onShippingChange = function () {
    var val = this.selectedShipping();
    if (val === 'final_customer') {
      this.formState.shippingMode = 'final_customer';
      this.showEndCustomer(true);
    } else if (val === 'partner_address') {
      if (this.endCustomerHasData()) {
        // Ne pas perdre silencieusement : restaurer la radio et demander confirmation
        this.pendingShippingMode = 'partner_address';
        this.setShippingTo('final_customer');
        this.showDestinationConfirm();
      } else {
        this.formState.shippingMode = 'partner_address';
        this.purgeEndCustomer();
        this.formStatus('');
      }
    }
  };

  Instance.prototype.showDestinationConfirm = function () {
    if (!this.destConfirmEl) { return; }
    this.destConfirmEl.hidden = false;
    var btn = this.destConfirmEl.querySelector('[data-pp-destination-confirm]');
    if (btn && typeof btn.focus === 'function') { btn.focus(); }
  };
  Instance.prototype.hideDestinationConfirm = function () {
    if (this.destConfirmEl) { this.destConfirmEl.hidden = true; }
  };
  Instance.prototype.confirmDestinationChange = function () {
    this.purgeEndCustomer();
    this.setShippingTo('partner_address');
    this.formState.shippingMode = 'partner_address';
    this.pendingShippingMode = null;
    this.hideDestinationConfirm();
    this.formStatus('Coordonnées du client final supprimées. Livraison à l’adresse professionnelle sélectionnée.');
    this.focusShipping('partner_address');
  };
  Instance.prototype.cancelDestinationChange = function () {
    this.pendingShippingMode = null;
    this.setShippingTo('final_customer');
    this.formState.shippingMode = 'final_customer';
    this.hideDestinationConfirm();
    this.formStatus('');
    this.focusShipping('final_customer');
  };

  /* ---------- validation d'un champ client final ---------- */
  Instance.prototype.validateEcField = function (key) {
    var input = this.ecInputs[key];
    if (!input) { return null; }
    var conf = null;
    for (var i = 0; i < EC_FIELDS.length; i++) { if (EC_FIELDS[i].key === key) { conf = EC_FIELDS[i]; break; } }
    if (!conf) { return null; }
    var v = String(input.value).trim();

    if (key === 'address2') { return null; } // seul champ facultatif

    if (conf.required && v === '') {
      return { field: 'shipping.end_customer.' + key, code: 'required', message: 'Ce champ est obligatoire.', element: input };
    }
    if (v === '') { return null; }

    if (key === 'email') {
      var nativeBad = input.validity && input.validity.typeMismatch;
      if (nativeBad || !looksLikeEmail(v)) {
        return { field: 'shipping.end_customer.email', code: 'invalid_email', message: 'Saisissez une adresse e-mail valide.', element: input };
      }
    }
    if (key === 'phone') {
      if (phoneDigitCount(v) < 6) {
        return { field: 'shipping.end_customer.phone', code: 'invalid_phone', message: 'Indiquez un numéro de téléphone valide.', element: input };
      }
    }
    if (key === 'country') {
      if (EC_COUNTRIES.indexOf(v) === -1) {
        return { field: 'shipping.end_customer.country', code: 'invalid_country', message: 'Sélectionnez un pays.', element: input };
      }
    }
    return null;
  };

  Instance.prototype.showFieldError = function (key, err) {
    var errEl = this.ecErrors[key];
    var input = this.ecInputs[key];
    if (!errEl) { return; }
    if (err) {
      errEl.textContent = err.message;
      errEl.hidden = false;
      if (input) { input.setAttribute('aria-invalid', 'true'); input.classList.add('pp__input--invalid'); }
    } else {
      errEl.textContent = '';
      errEl.hidden = true;
      if (input) { input.removeAttribute('aria-invalid'); input.classList.remove('pp__input--invalid'); }
    }
  };

  Instance.prototype.syncEndCustomerState = function () {
    if (this.formState.shippingMode !== 'final_customer') { return; }
    var ec = {};
    for (var i = 0; i < EC_FIELDS.length; i++) {
      var k = EC_FIELDS[i].key;
      var input = this.ecInputs[k];
      ec[k] = input ? input.value : '';
    }
    this.formState.endCustomer = ec;
  };

  Instance.prototype.onEcBlur = function (key) {
    this.formState.touched.add(key);
    this.syncEndCustomerState();
    this.showFieldError(key, this.validateEcField(key));
  };
  Instance.prototype.onEcInput = function (key) {
    this.syncEndCustomerState();
    // Ne révèle une erreur que sur un champ déjà touché (jamais sur un champ vierge)
    if (this.formState.touched.has(key)) {
      this.showFieldError(key, this.validateEcField(key));
    }
  };

  /* ---------- validation globale (préparation ; ne débloque jamais le bouton) ---------- */
  Instance.prototype.validateRequestState = function (options) {
    options = options || {};
    var showAll = !!options.showAll;
    var errors = [];
    function push(field, code, message, element) {
      errors.push({ field: field, code: code, message: message, element: element || null });
    }

    /* La référence du partenaire est devenue obligatoire : c’est elle qui nomme
       la demande dans « Mes demandes ». Sans elle, la liste retombe sur une date,
       et un photographe qui suit dix commandes ne reconnaît plus les siennes.
       Elle est vérifiée en premier, dans l’ordre où le formulaire se remplit. */
    if (!trimOrNull(this.refInput ? this.refInput.value : '')) {
      push('partner_internal_reference', 'reference_required', 'Indiquez votre référence pour cette commande.', this.refInput);
    }
    /* Modèle de lampe — trois refus distincts, à ne pas confondre.

       Tant que la disponibilité n'est pas connue, on parle d'une vérification
       en cours ou impossible, jamais d'une taille indisponible : dire l'un
       pour l'autre inventerait une décision commerciale.

       Le refus d'une taille fermée est une ceinture : le rendu la décoche déjà.
       Il couvre le cas où ce rendu n'aurait pas été rejoué — et il ne remplace
       toujours pas le contrôle serveur, seul à trancher. */
    var tailleChoisie = this.currentModele();
    if (!this.modelAvailabilityReady()) {
      push('model_size', 'model_availability_unknown',
        (this.modeleVue && this.modeleVue.etat === 'error') ? MODELE_MSG_ERREUR : MODELE_MSG_ATTENTE,
        null);
    } else if (!tailleChoisie) {
      push('model_size', 'model_required', 'Choisissez un modèle de lampe.', null);
    } else if (!this.modelSizeOpen(tailleChoisie)) {
      push('model_size', 'model_unavailable', MODELE_MSG_RETIRE, null);
    }
    if (!isLayout(this.layout)) {
      push('photo_layout', 'layout_required', 'Choisissez la disposition des photographies.', null);
    }
    if (this.currentQuantite() === null) {
      push('quantity', 'quantity_invalid',
        'Indiquez un nombre d\u2019exemplaires entier, de ' + QUANTITE_MIN + ' \u00e0 ' + QUANTITE_MAX + '.',
        this.quantiteInput);
    }
    if (!this.consentGiven()) {
      push('consents.production_rights', 'consent_required', 'Confirmez l’autorisation de traitement.', this.consentEl);
    }
    var roles = rolesForLayout(this.layout);
    for (var r = 0; r < roles.length; r++) {
      var slot = this.slots[roles[r]];
      if (!slot || slot.state !== 'ready') {
        push('photos.' + roles[r], 'photo_required', 'Ajoutez la photographie requise.', null);
      }
    }
    if (!this.currentSocle()) {
      push('base_color', 'base_color_required', 'Choisissez la couleur du socle.', null);
    }
    var ship = this.selectedShipping();
    if (!ship) {
      push('shipping.mode', 'shipping_required', 'Choisissez une destination d’expédition.', null);
    }
    if (ship === 'final_customer') {
      for (var i = 0; i < EC_FIELDS.length; i++) {
        var err = this.validateEcField(EC_FIELDS[i].key);
        if (err) { push(err.field, err.code, err.message, err.element); }
      }
    }
    if (this.refInput && codePointLength(this.refInput.value) > COUNTER_CONF.partner_internal_reference.max) {
      push('partner_internal_reference', 'too_long', 'La référence dépasse 50 caractères.', this.refInput);
    }
    if (this.textInput && codePointLength(this.textInput.value) > COUNTER_CONF.text.max) {
      push('text', 'too_long', 'Le texte dépasse 50 caractères.', this.textInput);
    }
    if (this.instrInput && codePointLength(this.instrInput.value) > COUNTER_CONF.instructions.max) {
      push('instructions', 'too_long', 'Les instructions dépassent 250 caractères.', this.instrInput);
    }

    if (showAll) {
      if (ship === 'final_customer') {
        for (var t = 0; t < EC_FIELDS.length; t++) {
          var key = EC_FIELDS[t].key;
          this.formState.touched.add(key);
          this.showFieldError(key, this.validateEcField(key));
        }
      }
      this.renderErrorSummary(errors);
    }
    return { valid: errors.length === 0, errors: errors };
  };

  Instance.prototype.renderErrorSummary = function (errors) {
    if (!this.errorSummaryEl) { return; }
    this.errorSummaryEl.innerHTML = '';
    if (!errors || !errors.length) { this.errorSummaryEl.hidden = true; return; }
    var title = el('p', 'pp__error-summary-title');
    title.textContent = 'Vérifiez les informations suivantes :';
    this.errorSummaryEl.appendChild(title);
    var list = el('ul', 'pp__error-summary-list');
    for (var i = 0; i < errors.length; i++) {
      var li = el('li', 'pp__error-summary-item');
      if (errors[i].element && errors[i].element.id) {
        var a = el('a', 'pp__error-summary-link');
        a.href = '#' + errors[i].element.id;
        a.textContent = errors[i].message;
        (function (target) {
          a.addEventListener('click', function (ev) {
            ev.preventDefault();
            if (target && typeof target.focus === 'function') { target.focus(); }
          });
        })(errors[i].element);
        li.appendChild(a);
      } else {
        li.textContent = errors[i].message;
      }
      list.appendChild(li);
    }
    this.errorSummaryEl.appendChild(list);
    this.errorSummaryEl.hidden = false;
    if (typeof this.errorSummaryEl.focus === 'function') { this.errorSummaryEl.focus(); }
  };

  /* ---------- brouillon normalisé (pur : aucune écriture, aucun réseau, aucun log) ---------- */
  Instance.prototype.buildProfessionalRequestDraft = function () {
    var photos = [];
    var roles = rolesForLayout(this.layout);
    for (var r = 0; r < roles.length; r++) {
      var slot = this.slots[roles[r]];
      if (!slot || slot.state !== 'ready') { continue; }
      photos.push({
        role: roles[r],
        uuid: slot.uuid ? slot.uuid : null,
        cdn_url: slot.cdnUrl ? slot.cdnUrl : null,
        name: slot.name ? slot.name : null,
        size_bytes: (typeof slot.size === 'number') ? slot.size : null,
        width: (typeof slot.width === 'number') ? slot.width : null,
        height: (typeof slot.height === 'number') ? slot.height : null
      });
    }

    var draft = {
      schema_version: 'pp-draft-v4',
      source: 'partner_portal',
      partner_internal_reference: trimOrNull(this.refInput ? this.refInput.value : ''),
      model_size: this.currentModele(),
      /* photo_layout est obligatoire en v3 et interdit en v1/v2 : les deux
         voyagent donc ensemble, jamais l'un sans l'autre. composition est
         derivee de la disposition, jamais saisie : le serveur refuse (422)
         toute incoherence entre les deux. */
      photo_layout: isLayout(this.layout) ? this.layout : null,
      composition: compositionForLayout(this.layout),
      /* Nombre d'exemplaires IDENTIQUES. Rien d'autre n'est duplique : photos,
         texte, couleur et disposition restent uniques dans le payload.
         La quantite entre dans la signature du payload (JSON.stringify), donc
         dans la cle d'idempotence : changer le nombre produit une nouvelle cle
         et non un rejeu de la demande precedente. */
      quantity: this.currentQuantite(),
      photos: photos,
      customization: {
        text: trimOrNull(this.textInput ? this.textInput.value : ''),
        instructions: trimOrNull(this.instrInput ? this.instrInput.value : '')
      },
      base_color: this.currentSocle(),
      shipping: {
        mode: this.selectedShipping(),
        end_customer: null
      },
      consents: {
        production_rights: this.consentGiven(),
        content_reuse: !!(this.contentReuseEl && this.contentReuseEl.checked)
      }
    };

    if (draft.shipping.mode === 'final_customer') {
      var g = this.ecInputs;
      draft.shipping.end_customer = {
        first_name: g.first_name ? String(g.first_name.value).trim() : '',
        last_name: g.last_name ? String(g.last_name.value).trim() : '',
        address1: g.address1 ? String(g.address1.value).trim() : '',
        address2: trimOrNull(g.address2 ? g.address2.value : ''),
        postal_code: g.postal_code ? String(g.postal_code.value).trim() : '',
        city: g.city ? String(g.city.value).trim() : '',
        country: g.country ? String(g.country.value).trim() : '',
        email: g.email ? String(g.email.value).trim() : '',
        phone: g.phone ? String(g.phone.value).trim() : ''
      };
    }
    return draft;
  };

  /* ============================================================
     EXPRESS-7B — Soumission contrôlée (POST réel App Proxy)
     ============================================================ */

  /* ---------- Uploadcare : tous les rôles requis sont prêts ---------- */
  Instance.prototype.uploadcareReady = function () {
    var roles = rolesForLayout(this.layout);
    if (!roles.length) { return false; }
    for (var i = 0; i < roles.length; i++) {
      var slot = this.slots[roles[i]];
      if (!slot || slot.state !== 'ready') { return false; }
    }
    return true;
  };

  /* ---------- conditions d'activation du bouton (jamais autoritaire métier) ---------- */
  Instance.prototype.canSubmit = function () {
    if (this.submitting || this.submitted) { return false; }
    if (this.designMode) { return false; }
    /* Une tentative en attente se renvoie telle quelle : l'etat courant du
       formulaire ne conditionne pas ce renvoi, puisqu'il n'est pas envoye. */
    if (this.pendingAttempt) { return true; }
    // Formulaire réellement révélé (fail-closed : /me actif). Si un conteneur portail
    // existe, il doit être en état actif ; sinon (aperçu isolé) on ne bloque pas dessus.
    var portal = this.root.closest ? this.root.closest('[data-pp-root]') : null;
    if (portal && portal.getAttribute('data-pp-portal-state') !== 'active') { return false; }
    if (!this.consentGiven()) { return false; }
    /* Disponibilité inconnue : ni sélection ni envoi. Le bouton reste éteint
       pendant l'attente comme après un échec — la validation dira lequel. */
    if (!this.modelAvailabilityReady()) { return false; }
    if (!this.uploadcareReady()) { return false; }
    return this.validateRequestState({ showAll: false }).valid;
  };

  /* ---------- reflet visuel de l'état du bouton ---------- */
  Instance.prototype.updateSubmitButtonState = function () {
    if (!this.submitBtn) { return; }
    if (this.submitting) {
      this.submitBtn.disabled = true;
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('pp__button--disabled');
      this.submitBtn.textContent = 'Envoi en cours…';
      return;
    }
    if (this.submitted) {
      this.submitBtn.disabled = true;
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('pp__button--disabled');
      this.submitBtn.textContent = 'Demande envoyée';
      return;
    }
    /* Tentative incertaine : le bouton change de nature. Il ne propose plus
       d'envoyer une demande, mais de verifier celle qui est peut-etre deja
       partie. Le libelle le dit, et le bouton reste toujours utilisable. */
    if (this.pendingAttempt) {
      this.submitBtn.disabled = false;
      this.submitBtn.setAttribute('aria-disabled', 'false');
      this.submitBtn.classList.remove('pp__button--disabled');
      this.submitBtn.textContent = 'V\u00e9rifier et reprendre l\u2019envoi';
      return;
    }
    var ok = this.canSubmit();
    this.submitBtn.disabled = !ok;
    this.submitBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    this.submitBtn.classList.toggle('pp__button--disabled', !ok);
    this.submitBtn.textContent = this.submitBtnDefaultLabel;
  };

  /* ---------- messages d'erreur serveur / réseau (bloc global) ---------- */
  Instance.prototype.showSubmitError = function (msg) {
    if (!this.submitErrorEl) { this.formStatus(msg || ''); return; }
    if (!msg) {
      this.submitErrorEl.hidden = true;
      this.submitErrorEl.textContent = '';
      return;
    }
    this.submitErrorEl.textContent = msg;
    this.submitErrorEl.hidden = false;
    if (typeof this.submitErrorEl.focus === 'function') { this.submitErrorEl.focus(); }
  };
  Instance.prototype.clearSubmitError = function () { this.showSubmitError(null); };

  /* ---------- signature simple du payload (détection de changement) ---------- */
  Instance.prototype.payloadSignature = function (payload) {
    try { return JSON.stringify(payload); } catch (e) { return null; }
  };

  /* ---------- Idempotency-Key : réutilisée si même payload, régénérée sinon ---------- */
  Instance.prototype.ensureIdempotencyKey = function (signature) {
    if (!this.idempotencyKey || this.idempotencyPayloadSignature !== signature) {
      this.idempotencyKey = uuidV4();
      this.idempotencyPayloadSignature = signature;
    }
    return this.idempotencyKey;
  };

  /* ---------- lecture tolérante du corps JSON (jamais bloquant) ---------- */
  function readJsonSafe(res) {
    return res.json().then(function (d) { return d; }, function () { return null; });
  }

  /* ---------- mapper 422 tolérant (tableau, objet Laravel, fallback) ---------- */
  /* Retourne { fieldErrors: [{field, code, message}], uploadIssue: bool, generic: string|null } */
  function normalize422(body) {
    var out = { fieldErrors: [], uploadIssue: false, generic: null };
    var UPLOAD_CODES = ['upload_unreachable', 'upload_invalid_host', 'upload_invalid_type', 'upload_too_large'];
    if (body && body.errors) {
      if (Object.prototype.toString.call(body.errors) === '[object Array]') {
        for (var i = 0; i < body.errors.length; i++) {
          var e = body.errors[i] || {};
          var fe = { field: e.field || null, code: e.code || null, message: e.message || 'Champ invalide.' };
          out.fieldErrors.push(fe);
          if ((fe.code && UPLOAD_CODES.indexOf(fe.code) !== -1) ||
              (fe.field && fe.field.indexOf('photos') === 0)) { out.uploadIssue = true; }
        }
      } else if (typeof body.errors === 'object') {
        // Format Laravel : { "field": ["message", ...] }
        for (var key in body.errors) {
          if (!Object.prototype.hasOwnProperty.call(body.errors, key)) { continue; }
          var arr = body.errors[key];
          var msg = (Object.prototype.toString.call(arr) === '[object Array]' && arr.length) ? String(arr[0]) : String(arr);
          out.fieldErrors.push({ field: key, code: null, message: msg });
          if (key.indexOf('photos') === 0) { out.uploadIssue = true; }
        }
      }
    }
    if (!out.fieldErrors.length) {
      out.generic = (body && (body.error || body.message)) ? String(body.error || body.message) : null;
    }
    return out;
  }

  /* ---------- résolution d'un champ backend vers un champ client final ---------- */
  Instance.prototype.ecKeyFromField = function (field) {
    if (!field || field.indexOf('shipping.end_customer.') !== 0) { return null; }
    var key = field.slice('shipping.end_customer.'.length);
    return this.ecInputs[key] ? key : null;
  };

  /* ---------- application d'un 422 sur l'UI existante ---------- */
  Instance.prototype.apply422 = function (body) {
    var norm = normalize422(body);
    var summary = [];
    for (var i = 0; i < norm.fieldErrors.length; i++) {
      var fe = norm.fieldErrors[i];
      var ecKey = this.ecKeyFromField(fe.field);
      if (ecKey) {
        this.formState.touched.add(ecKey);
        this.showFieldError(ecKey, { message: fe.message });
        var input = this.ecInputs[ecKey];
        summary.push({ field: fe.field, code: fe.code, message: fe.message, element: input || null });
      } else {
        summary.push({ field: fe.field, code: fe.code, message: fe.message, element: null });
      }
    }
    if (summary.length) { this.renderErrorSummary(summary); }
    if (norm.uploadIssue) {
      this.showSubmitError('La photographie n’est plus accessible. Supprimez-la puis téléversez-la de nouveau.');
    } else if (norm.generic) {
      this.showSubmitError(norm.generic);
    } else if (!summary.length) {
      this.showSubmitError('Certaines informations sont invalides. Vérifiez le formulaire.');
    } else {
      this.clearSubmitError();
    }
  };

  /* ---------- affichage du succès (référence serveur uniquement) ---------- */
  /* Un enregistrement n'est tenu pour acquis que si la réponse le nomme.
     Le contrat renvoie professional_request_reference sur une création comme
     sur un rejeu ; sans elle, un 2xx ne prouve rien d'exploitable et le
     formulaire doit rester en l'état. */
  function reponseConfirmeEnregistrement(d) {
    return !!(d && typeof d === 'object' &&
      typeof d.professional_request_reference === 'string' &&
      d.professional_request_reference !== '');
  }

  Instance.prototype.showSuccess = function (data, replay) {
    var d = data || {};
    var confirme = reponseConfirmeEnregistrement(d);
    if (this.successEl) {
      var titleEl = this.successEl.querySelector('[data-pp-success-title]');
      var refEl = this.successEl.querySelector('[data-pp-success-reference]');
      var statusRow = this.successEl.querySelector('[data-pp-success-status-row]');
      var statusEl = this.successEl.querySelector('[data-pp-success-status]');
      var dateRow = this.successEl.querySelector('[data-pp-success-date-row]');
      var dateEl = this.successEl.querySelector('[data-pp-success-date]');
      if (titleEl) { titleEl.textContent = replay ? 'Demande déjà enregistrée' : 'Demande envoyée'; }
      if (refEl) { refEl.textContent = d.professional_request_reference ? String(d.professional_request_reference) : '—'; }
      if (statusEl && statusRow) {
        if (d.status) { statusEl.textContent = histStatusLabel(d.status); statusRow.hidden = false; }
        else { statusRow.hidden = true; }
      }
      if (dateEl && dateRow) {
        if (d.submitted_at) { dateEl.textContent = histFormatDate(d.submitted_at); dateRow.hidden = false; }
        else { dateRow.hidden = true; }
      }
      this.successEl.hidden = false;
      if (typeof this.successEl.focus === 'function') { this.successEl.focus(); }
    }
    this.clearSubmitError();
    if (this.errorSummaryEl) { this.errorSummaryEl.hidden = true; this.errorSummaryEl.innerHTML = ''; }
    this.submitted = true;
    this.submitting = false;
    this.updateSubmitButtonState();

    /* Réponse 2xx sans référence exploitable : l'envoi est peut-être passé,
       peut-être pas. On ne vide rien — la saisie est ce qui permettrait de
       réessayer — et on garde la clé d'idempotence, qui fera répondre au
       serveur un rejeu plutôt que de créer un doublon. */
    if (!confirme) {
      this.submitted = false;
      /* Meme incertitude que pour un 500 ou une coupure : le serveur a repondu
         2xx mais sans nommer la demande. La tentative reste epinglee par
         onSubmit, qui l'a posee avant l'envoi ; on se contente d'expliquer. */
      this.markAttemptUncertain();
      this.showSubmitError(this.messageTentativeEnAttente());
      this.updateSubmitButtonState();
    }

    // Rafraîchit l'historique pour refléter la demande créée. Encapsulé : un échec
    // du rafraîchissement ne masque jamais le succès affiché ci-dessus. Aucune seconde
    // soumission possible (this.submitted = true → bouton désactivé).
    try {
      var portalRoot = this.root && this.root.closest ? this.root.closest('[data-pp-root]') : null;
      var histHost = portalRoot ? portalRoot.querySelector('[data-pp-history]') : null;
      if (histHost && typeof histHost.__ppHistoryRefresh === 'function') { histHost.__ppHistoryRefresh(); }
    } catch (e) { /* rafraîchissement best-effort : le succès reste affiché */ }

    /* Formulaire rendu vierge pour la demande suivante. Le bandeau de
       confirmation ci-dessus n'est pas touché : il porte la référence de la
       demande qui vient de partir, c'est la seule trace immédiate dont dispose
       le photographe avant que l'historique ne se recharge. */
    if (confirme) { this.resetAfterSuccess(); }
  };

  /* ---------- instantané de l'état vierge ----------
     Relevé sur le DOM plutôt que reconstruit : ce que le Liquid a rendu fait
     foi. Aucune valeur n'est inventée, aucune case n'est cochée qui ne l'était
     pas — la remise à zéro rend exactement le formulaire de départ. */
  Instance.prototype.captureInitialSnapshot = function () {
    if (this.initialSnapshot) { return; }
    var champs = [];
    var noeuds = this.root.querySelectorAll('input, textarea, select');
    for (var i = 0; i < noeuds.length; i++) {
      var n = noeuds[i];
      champs.push({
        el: n,
        value: n.value,
        checked: !!n.checked,
        type: (n.type || '').toLowerCase()
      });
    }
    this.initialSnapshot = {
      champs: champs,
      ecHidden: this.ecFieldset ? this.ecFieldset.hidden : null,
      ecDisabled: this.ecFieldset ? this.ecFieldset.disabled : null
    };
  };

  /* ---------- remise à zéro après un succès confirmé ----------
     Portée : le formulaire de création, et lui seul. Ni la session, ni
     l'identité partenaire, ni l'historique, ni le formulaire de complément ne
     sont touchés — ils vivent hors de this.root.

     Les fichiers déjà transmis ne sont pas supprimés : vider un emplacement ne
     fait qu'oublier une référence côté navigateur. Les photographies de la
     demande enregistrée restent chez Uploadcare et rattachées à la demande. */
  Instance.prototype.resetAfterSuccess = function () {
    /* 1. Toute promesse de téléversement encore en vol devient caduque. */
    this.formEpoch++;

    /* 2. Champs : retour exact à l'instantané initial. */
    var snap = this.initialSnapshot;
    if (snap) {
      for (var i = 0; i < snap.champs.length; i++) {
        var c = snap.champs[i];
        if (c.type === 'checkbox' || c.type === 'radio') { c.el.checked = c.checked; }
        else { c.el.value = c.value; }
      }
      if (this.ecFieldset && snap.ecHidden !== null) {
        this.ecFieldset.hidden = snap.ecHidden;
        this.ecFieldset.disabled = snap.ecDisabled;
      }
    }

    /* 3. Disposition et emplacements de téléversement. */
    this.layout = null;
    this.pendingLayout = null;
    this.slots = {};
    this.renderSlots();
    this.hideModeConfirm();
    if (this.destConfirmEl) { this.destConfirmEl.hidden = true; }
    this.pendingShippingMode = null;

    /* 4. Miroir local, compteurs, messages. */
    this.formState.partnerInternalReference = '';
    this.formState.text = '';
    this.formState.instructions = '';
    this.formState.baseColor = null;
    this.formState.shippingMode = this.selectedShipping();
    this.formState.endCustomer = null;
    this.formState.productionRightsConsent = this.consentGiven();
    this.formState.contentReuseConsent = !!(this.contentReuseEl && this.contentReuseEl.checked);
    this.formState.touched = new Set();
    this.updateAllCounters();
    /* La valeur « 1 » revient par l'instantane initial, comme les autres champs.
       Ne restent a rafraichir que les deux rendus qui en dependent. */
    this.updateQuantiteError();
    this.updateRecap();
    this.clearSubmitError();
    if (this.errorSummaryEl) { this.errorSummaryEl.hidden = true; this.errorSummaryEl.innerHTML = ''; }
    for (var k in this.ecErrors) {
      if (Object.prototype.hasOwnProperty.call(this.ecErrors, k) && this.ecErrors[k]) {
        this.ecErrors[k].textContent = '';
        this.ecErrors[k].hidden = true;
      }
    }
    this.status('');

    /* 5. État de soumission : la demande suivante repart d'une clé neuve.
       La clé n'est remise à null qu'ici, après un enregistrement confirmé —
       jamais après une erreur, où sa conservation est ce qui protège du
       doublon lors d'un réessai. */
    this.submitted = false;
    this.submitting = false;
    this.idempotencyKey = null;
    this.idempotencyPayloadSignature = null;
    /* La tentative est resolue : une creation suivante repart d'une cle neuve,
       et le formulaire redevient modifiable. */
    this.clearAttempt();
    this.setFormLocked(false);
    this.updateSubmitButtonState();
  };

  /* ---------- tentative au résultat incertain ----------

     Une demande peut avoir ete enregistree sans que le navigateur l'apprenne :
     coupure reseau, 500, reponse 2xx illisible. Si le photographe modifie alors
     sa saisie — la quantite, par exemple — le payload change, donc sa signature,
     donc la cle d'idempotence : le reessai partirait sous une cle neuve et
     creerait une SECONDE demande, en silence.

     On epingle donc la tentative : cle et payload exacts sont conserves, et
     c'est CE payload que le prochain envoi renvoie, quoi qu'affiche le
     formulaire. Le serveur tranche alors lui-meme, avec le mecanisme qu'il a
     deja : meme cle et meme payload renvoient la demande existante (200) si
     elle avait ete creee, ou la creent (201) si elle ne l'avait pas ete. Une
     seule demande dans les deux cas.

     A distinguer d'un refus EXPLICITE — 422, 401, 403, 429 : le serveur y dit
     n'avoir rien cree. Aucune tentative n'est epinglee, et le photographe
     retrouve la main sur son formulaire. */
  /* ---------- verrouillage du formulaire ----------

     Des qu'un envoi commence, les champs de creation et les actions sur les
     photographies cessent de repondre. La raison n'est pas cosmetique : si le
     resultat devient incertain, la reprise renverra le payload epingle, pas ce
     qui est a l'ecran. Laisser modifier l'ecran ferait diverger les deux, et le
     photographe croirait corriger une demande qu'il ne corrige pas.

     Deux choses restent utilisables, volontairement : le bouton d'envoi — c'est
     par lui que passe la reprise — et le bloc « Mes demandes », qui vit hors de
     this.root et n'est donc jamais touche ici. */
  Instance.prototype.setFormLocked = function (locked) {
    this.locked = !!locked;
    this.root.setAttribute('data-pp-locked', this.locked ? 'true' : 'false');

    var champs = this.root.querySelectorAll('input, textarea, select, fieldset');
    for (var i = 0; i < champs.length; i++) {
      var c = champs[i];
      if (c === this.submitBtn) { continue; }
      c.disabled = this.locked;
    }
    /* Les emplacements sont redessines : leurs boutons ne reapparaissent pas
       tant que le verrou tient (voir paintSlot). */
    this.renderSlots();
    /* Le deverrouillage vient de reactiver TOUS les champs, y compris les
       modeles que le serveur a fermes. On repose aussitot l'etat connu :
       sans cela, une taille indisponible redeviendrait cliquable apres un
       envoi repris ou une remise a zero. Pendant le verrou, rien n'est
       reactive : la boucle ci-dessus a deja tout desactive. */
    if (!this.locked) { this.reassertModelAvailability(); }
    this.updateSubmitButtonState();
  };

  /* Message unique des issues incertaines : dire ce qu'on ignore, et ce que
     fera le prochain clic. Ne jamais affirmer qu'aucune demande n'a ete creee. */
  /* Message des issues incertaines. Il dit ce qu'on ignore et ce que fera le
     bouton. Il ne promet pas qu'aucun doublon n'est possible : cette protection
     ne vaut que pour l'onglet ouvert, et une promesse générale serait fausse. */
  Instance.prototype.messageTentativeEnAttente = function () {
    return 'La confirmation n’a pas été reçue. ' +
      'Reprenez l’envoi pour vérifier l’enregistrement de cette demande.';
  };

  /* Tentative qui part sur le reseau. Retenue sans prejuger de son issue. */
  Instance.prototype.beginAttempt = function (payload, key) {
    this.currentAttempt = { key: key, payload: payload };
  };

  /* L'issue est devenue incertaine : la tentative passe en attente de
     resolution. Une tentative deja en attente n'est PAS remplacee — c'est la
     premiere qui a pu creer une demande, et c'est elle qu'il faut resoudre. */
  Instance.prototype.markAttemptUncertain = function () {
    if (this.pendingAttempt) { return; }
    if (!this.currentAttempt) { return; }
    this.pendingAttempt = {
      key: this.currentAttempt.key,
      payload: this.currentAttempt.payload,
      signature: this.payloadSignature(this.currentAttempt.payload)
    };
  };

  /* Oubli d'une tentative en attente. N'est legitime que dans deux cas :
     enregistrement CONFIRME, ou refus explicite d'une PREMIERE tentative — la
     ou le serveur atteste n'avoir rien cree. Jamais sur le simple code HTTP du
     refus d'une reprise : ce code ne dit rien de ce qu'a fait la tentative
     precedente. */
  /* Refus EXPLICITE recu (422, 401, 403, 429).

     S'il refuse une PREMIERE tentative, il atteste que rien n'a ete cree : on
     oublie, et le photographe reprend la main sur sa saisie.

     S'il refuse une REPRISE, il ne dit rien de la tentative precedente — celle
     dont la reponse s'etait perdue, et qui a pu creer une demande. Une session
     expiree ou un limiteur n'effacent pas ce qui a peut-etre ete enregistre.
     La tentative reste alors en attente, et le formulaire verrouille, jusqu'a
     confirmation de la demande. */
  Instance.prototype.forgetAttemptIfFirst = function () {
    if (this.pendingAttempt) { return; }
    this.clearAttempt();
    this.setFormLocked(false);
  };

  Instance.prototype.clearAttempt = function () {
    this.pendingAttempt = null;
    this.currentAttempt = null;
  };

  /* ---------- fin d'une tentative récupérable (réactive le bouton) ---------- */
  Instance.prototype.endRecoverable = function () {
    this.submitting = false;
    this.updateSubmitButtonState();
  };

  /* ---------- soumission principale ---------- */
  Instance.prototype.onSubmit = function () {
    if (this.submitting || this.submitted) { return; }

    var payload, key;

    if (this.pendingAttempt) {
      /* Une tentative attend d'etre resolue. On renvoie sa cle et SON payload,
         a l'identique — pas le contenu courant du formulaire, que le photographe
         a pu modifier entre-temps. C'est la seule maniere de laisser le serveur
         reconnaitre la demande deja enregistree plutot que d'en creer une
         seconde. Aucune validation du formulaire ici : ce payload a deja passe
         la validation au moment de son premier envoi. */
      payload = this.pendingAttempt.payload;
      key = this.pendingAttempt.key;
    } else {
      var check = this.validateRequestState({ showAll: true });
      if (!check.valid) {
        this.showSubmitError('Vérifiez les informations avant l’envoi.');
        return;
      }
      if (!this.uploadcareReady()) {
        this.showSubmitError('Ajoutez la ou les photographies requises avant l’envoi.');
        return;
      }

      payload = this.buildProfessionalRequestDraft();
      key = this.ensureIdempotencyKey(this.payloadSignature(payload));
      if (!key) {
        this.showSubmitError('Impossible de préparer l’envoi sécurisé sur ce navigateur. Réessayez.');
        return;
      }
    }

    this.clearSubmitError();
    this.submitting = true;
    /* Verrou pose AVANT le depart de la requete : a partir d'ici, ce qui est
       affiche doit correspondre a ce qui part. */
    this.setFormLocked(true);
    this.updateSubmitButtonState();

    /* Epingle DES MAINTENANT, avant que la requete ne parte : si la page se
       ferme ou que la reponse se perd, l'etat en memoire porte deja de quoi
       rejouer exactement cette tentative. Les issues explicites la retirent. */
    this.beginAttempt(payload, key);

    var self = this;
    window.fetch(SUBMIT_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Idempotency-Key': key
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      var status = res ? res.status : 0;
      if (status === 201) {
        return readJsonSafe(res).then(function (d) { self.showSuccess(d, false); });
      }
      if (status === 200) {
        return readJsonSafe(res).then(function (d) { self.showSuccess(d, true); });
      }
      if (status === 409) {
        self.showSubmitError('Cette tentative d’envoi est en conflit. Rechargez la page avant de réessayer.');
        self.submitting = false;
        self.updateSubmitButtonState();
        return;
      }
      if (status === 422) {
        return readJsonSafe(res).then(function (d) {
          /* 422 : refus EXPLICITE. Le serveur dit n'avoir rien cree — aucune
             tentative a resoudre, le photographe reprend la main sur sa saisie. */
          self.forgetAttemptIfFirst();
          self.apply422(d);
          self.endRecoverable();
        });
      }
      if (status === 429) {
        /* Refus explicite du limiteur : la requete n'a pas ete traitee. */
        self.forgetAttemptIfFirst();
        self.showSubmitError('Trop de tentatives. Patientez quelques instants avant de réessayer.');
        self.endRecoverable();
        return;
      }
      if (status === 401) {
        /* Refus explicite : requete non authentifiee, donc non traitee. */
        self.forgetAttemptIfFirst();
        self.showSubmitError('Votre session a expiré. Reconnectez-vous pour envoyer votre demande.');
        self.submitting = false;
        self.updateSubmitButtonState();
        return;
      }
      if (status === 403) {
        // Partenaire non autorisé / inactif → fail-closed comme /me.
        var portal = self.root.closest ? self.root.closest('[data-pp-root]') : null;
        if (portal) { authFailClosed(portal); }
        self.forgetAttemptIfFirst();
        self.showSubmitError('Votre accès partenaire n’est pas actif. Contactez notre équipe.');
        self.submitting = false;
        return;
      }
      /* 500 et autres statuts serveur : l'issue est INCONNUE. La demande a pu
         etre enregistree avant la panne. On epingle la tentative pour que le
         reessai reparte a l'identique. */
      self.markAttemptUncertain();
      self.showSubmitError(self.messageTentativeEnAttente());
      self.endRecoverable();
    }).catch(function () {
      /* Erreur reseau : on ne sait pas si la requete est parvenue au serveur.
         Rien ici ne permet de conclure a une absence de creation — meme
         epinglage. */
      self.markAttemptUncertain();
      self.showSubmitError(self.messageTentativeEnAttente());
      self.endRecoverable();
    });
  };

  /* ---------- init d'une racine ---------- */
  Instance.prototype.init = function () {
    var self = this;

    // Nombre d'exemplaires
    if (this.quantiteInput) {
      var majQuantite = function () {
        self.updateQuantiteError();
        self.updateRecap();
        self.updateSubmitButtonState();
      };
      this.quantiteInput.addEventListener('input', majQuantite);
      this.quantiteInput.addEventListener('change', majQuantite);
    }
    // Le recapitulatif suit aussi le choix du modele : c'est lui qui porte le prix.
    for (var mq = 0; mq < this.modeleRadios.length; mq++) {
      this.modeleRadios[mq].addEventListener('change', function () { self.updateRecap(); });
    }

    // Disposition des photographies
    for (var i = 0; i < this.layoutRadios.length; i++) {
      this.layoutRadios[i].addEventListener('change', function () {
        self.onCompositionChange();
        self.updateSubmitButtonState();
      });
    }
    // Consentement obligatoire
    if (this.consentEl) {
      this.consentEl.addEventListener('change', function () {
        self.onConsentChange();
        self.formState.productionRightsConsent = self.consentGiven();
        self.updateSubmitButtonState();
      });
    }
    // Confirmation de changement de mode
    if (this.confirmEl) {
      var cok = this.confirmEl.querySelector('[data-pp-mode-confirm]');
      var cno = this.confirmEl.querySelector('[data-pp-mode-cancel]');
      if (cok) { cok.addEventListener('click', function () { self.confirmModeChange(); }); }
      if (cno) { cno.addEventListener('click', function () { self.cancelModeChange(); }); }
    }

    // Compteurs de caractères
    if (this.refInput) {
      this.refInput.addEventListener('input', function () {
        self.updateCounter('partner_internal_reference');
        self.formState.partnerInternalReference = self.refInput.value;
        self.updateSubmitButtonState();
      });
    }
    if (this.textInput) {
      this.textInput.addEventListener('input', function () {
        self.updateCounter('text');
        self.formState.text = self.textInput.value;
        self.updateSubmitButtonState();
      });
    }
    if (this.instrInput) {
      this.instrInput.addEventListener('input', function () {
        self.updateCounter('instructions');
        self.formState.instructions = self.instrInput.value;
        self.updateSubmitButtonState();
      });
    }

    // Modèle de lampe
    for (var md = 0; md < this.modeleRadios.length; md++) {
      this.modeleRadios[md].addEventListener('change', function () {
        /* Le partenaire vient de rechoisir : la demande de rechoisir n'a plus
           lieu d'être. Les mentions « Bientôt disponible », elles, restent —
           elles décrivent les tailles, pas cette saisie. */
        if (self.modeleVue && self.modeleVue.avis) {
          self.modeleVue.avis = '';
          rendreDisponibiliteModeles(self.modeleVue);
        }
        self.updateSubmitButtonState();
      });
    }

    // Couleur du socle
    for (var s = 0; s < this.socleRadios.length; s++) {
      this.socleRadios[s].addEventListener('change', function () {
        self.formState.baseColor = self.currentSocle();
        self.updateSubmitButtonState();
      });
    }

    // Destination d'expédition
    for (var d = 0; d < this.shippingRadios.length; d++) {
      this.shippingRadios[d].addEventListener('change', function () {
        self.onShippingChange();
        self.updateSubmitButtonState();
      });
    }
    // Confirmation de changement de destination
    if (this.destConfirmEl) {
      var dok = this.destConfirmEl.querySelector('[data-pp-destination-confirm]');
      var dno = this.destConfirmEl.querySelector('[data-pp-destination-cancel]');
      if (dok) { dok.addEventListener('click', function () { self.confirmDestinationChange(); }); }
      if (dno) { dno.addEventListener('click', function () { self.cancelDestinationChange(); }); }
    }

    // Consentement facultatif
    if (this.contentReuseEl) {
      this.contentReuseEl.addEventListener('change', function () {
        self.formState.contentReuseConsent = !!self.contentReuseEl.checked;
      });
    }

    // Consentement facultatif (mis à jour du bouton pour cohérence, sans le conditionner)
    if (this.contentReuseEl) {
      this.contentReuseEl.addEventListener('change', function () {
        self.updateSubmitButtonState();
      });
    }

    // Champs client final (input + change + blur)
    for (var e = 0; e < EC_FIELDS.length; e++) {
      (function (key) {
        var input = self.ecInputs[key];
        if (!input) { return; }
        input.addEventListener('input', function () { self.onEcInput(key); self.updateSubmitButtonState(); });
        input.addEventListener('change', function () { self.onEcInput(key); self.updateSubmitButtonState(); });
        input.addEventListener('blur', function () { self.onEcBlur(key); self.updateSubmitButtonState(); });
      })(EC_FIELDS[e].key);
    }

    // Soumission : POST réel via App Proxy (jamais d'envoi natif Shopify)
    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        self.onSubmit();
      });
    }
    if (this.form) {
      this.form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        self.onSubmit();
      });
    }

    // État initial
    this.layout = isLayout(this.currentRadioMode()) ? this.currentRadioMode() : null;
    this.formState.shippingMode = this.selectedShipping();
    this.formState.baseColor = this.currentSocle();
    this.formState.productionRightsConsent = this.consentGiven();
    this.formState.contentReuseConsent = !!(this.contentReuseEl && this.contentReuseEl.checked);
    this.updateAllCounters();
    this.updateQuantiteError();
    this.updateRecap();
    this.renderSlots();
    /* Premier rendu de la disponibilité : état d'attente. Les modèles partent
       donc désactivés, avant même la réponse de /me. C'est l'inverse du
       réflexe habituel — on n'ouvre pas « en attendant de savoir ». */
    this.reassertModelAvailability();
    this.updateSubmitButtonState();

    /* Instantané de l'état vierge, pris une seule fois, une fois le DOM en
       place et avant toute saisie : c'est lui que restaure resetAfterSuccess. */
    this.captureInitialSnapshot();
  };

  /* ---------- bootstrap ---------- */
  function initRoot(root) {
    if (!root || root.getAttribute('data-pp-initialized') === 'true') { return; }
    root.setAttribute('data-pp-initialized', 'true');
    var inst = new Instance(root);
    PP.instances.set(root, inst);
    inst.init();
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    // 1. Identité PHO (EXPRESS-5) : révèle le formulaire fail-closed après /me actif.
    var authRoots = ctx.querySelectorAll('[data-pp-root]');
    for (var a = 0; a < authRoots.length; a++) { initAuth(authRoots[a]); }
    // 2. Formulaire (Uploadcare / brouillon / validation locale).
    var roots = ctx.querySelectorAll('[data-pp-request]');
    for (var i = 0; i < roots.length; i++) { initRoot(roots[i]); }
  }

  /* ---------- EXPRESS-5 : identité PHO réelle via App Proxy signé (fail-closed) ----------
     Appelle GET <data-pp-me-endpoint> (défaut /apps/partner-portal/me). N'accepte QUE
     HTTP 200 + JSON { first_name, company_name, partner_code, partner_status } avec
     partner_status === 'active'. Toute autre issue (401/403/404/500, réseau, JSON
     invalide, clé manquante, statut non actif) = fail-closed : identité et formulaire
     masqués. Aucune confiance navigateur, aucun stockage (localStorage/sessionStorage),
     aucun token, aucune réactivation du bouton d'envoi. Une seule requête par section. */
  var PP_STATUS_LABELS = { active: 'Actif' };

  function ppShow(el) { if (el) { el.hidden = false; } }
  function ppHide(el) { if (el) { el.hidden = true; } }
  function ppSetText(root, sel, value) {
    var el = root.querySelector(sel);
    // textContent uniquement : aucune injection HTML possible.
    if (el) { el.textContent = (value == null) ? '' : String(value); }
  }

  /* Passe l'état de disponibilité du serveur au formulaire de ce portail.
     `brut` est la valeur de model_sizes telle qu'elle arrive — non lue ici :
     setModelAvailability la juge, et bascule en erreur si elle est illisible.
     Passer undefined (aucune clé model_sizes) aboutit donc à l'état error,
     jamais à l'ouverture des trois tailles. */
  function applyModelSizes(form, brut) {
    if (!form) { return; }
    var inst = PP.instances.get(form);
    if (!inst) { initRoot(form); inst = PP.instances.get(form); }
    if (!inst) { return; }
    inst.setModelAvailability(brut);
  }

  function authFailClosed(root) {
    root.setAttribute('data-pp-portal-state', 'denied');
    ppHide(root.querySelector('[data-pp-auth-loading]'));
    ppHide(root.querySelector('[data-pp-identity]'));
    ppHide(root.querySelector('[data-pp-portal-form]'));
    ppShow(root.querySelector('[data-pp-auth-error]'));
    // Le bouton d'envoi reste désactivé : jamais réactivé ici.
    /* Le formulaire est masqué, mais son instance existe peut-être déjà : on
       la laisse en état d'attente plutôt que de la laisser croire un jour à
       une disponibilité. Rien ne rouvre de taille sur un accès refusé. */
    var form = root.querySelector('[data-pp-request]');
    var inst = form ? PP.instances.get(form) : null;
    if (inst) { inst.setModelAvailabilityError(); }
  }

  function authRevealActive(root, data) {
    ppSetText(root, '[data-pp-first-name]', data.first_name);
    ppSetText(root, '[data-pp-company-name]', data.company_name);
    ppSetText(root, '[data-pp-partner-code]', data.partner_code);
    ppSetText(root, '[data-pp-partner-status]', PP_STATUS_LABELS[data.partner_status] || data.partner_status);
    ppHide(root.querySelector('[data-pp-auth-loading]'));
    ppHide(root.querySelector('[data-pp-auth-error]'));
    ppShow(root.querySelector('[data-pp-identity]'));
    ppShow(root.querySelector('[data-pp-portal-form]'));
    root.setAttribute('data-pp-portal-state', 'active');
    // Le formulaire devient visible : on l'initialise (idempotent) pour Uploadcare/brouillon/validation.
    var form = root.querySelector('[data-pp-request]');
    if (form) { initRoot(form); }
    /* Disponibilité des modèles — même réponse, même requête : model_sizes
       voyage avec l'identité. Aucun second appel, aucune seconde liste.
       Une clé absente ou mal formée n'invalide PAS l'accès au portail : le
       partenaire garde son identité, son historique et sa saisie, seul le
       choix du modèle passe en erreur de chargement. */
    applyModelSizes(form, data.model_sizes);
    // Le bouton d'envoi reste désactivé (EXPRESS-5 ne l'active pas).
    // EXPRESS-8C — Historique PHO (lecture seule) : révélé + initialisé UNIQUEMENT ici,
    // après confirmation serveur 200 + active. Jamais chargé sinon.
    var history = root.querySelector('[data-pp-history]');
    if (history) { ppShow(history); initHistory(root); }
  }

  function isValidMePayload(d) {
    if (!d || typeof d !== 'object') { return false; }
    var keys = ['first_name', 'company_name', 'partner_code', 'partner_status'];
    for (var k = 0; k < keys.length; k++) {
      if (typeof d[keys[k]] !== 'string' || d[keys[k]] === '') { return false; }
    }
    // Les clés supplémentaires éventuelles sont ignorées (jamais consommées).
    return d.partner_status === 'active';
  }

  function initAuth(root) {
    if (!root || root.getAttribute('data-pp-auth-initialized') === 'true') { return; }
    root.setAttribute('data-pp-auth-initialized', 'true');
    root.setAttribute('data-pp-portal-state', 'loading');

    var endpoint = root.getAttribute('data-pp-me-endpoint') || '/apps/partner-portal/me';
    if (typeof window.fetch !== 'function') { authFailClosed(root); return; }

    window.fetch(endpoint, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    }).then(function (res) {
      if (!res || res.status !== 200) { authFailClosed(root); return; }
      return res.json().then(function (data) {
        if (isValidMePayload(data)) { authRevealActive(root, data); }
        else { authFailClosed(root); }
      }).catch(function () { authFailClosed(root); });
    }).catch(function () { authFailClosed(root); });
  }

  /* ============================================================
     EXPRESS-8C — Historique PHO (lecture seule)
     Module SÉPARÉ du formulaire. Aucune écriture, aucun POST, aucun stockage.
     Rendu 100 % via createElement/textContent (jamais innerHTML avec contenu serveur).
     Le navigateur n'est jamais autoritaire : le statut affiché n'ouvre aucun droit.
     ============================================================ */
  var HIST_STATUS_LABELS = {
    submitted: 'Demande envoyée',
    under_review: 'En cours d’étude',
    needs_information: 'Complément demandé',
    accepted: 'Demande acceptée',
    approved: 'Demande acceptée',
    refused: 'Demande refusée',
    rejected: 'Demande refusée',
    cancelled: 'Annulée'
  };
  var HIST_DESTINATION_LABELS = {
    partner_address: 'À mon adresse professionnelle',
    final_customer: 'Directement chez mon client'
  };
  var HIST_COMPOSITION_LABELS = { '1': '1 photo', '2': '2 photos', 1: '1 photo', 2: '2 photos' };
  var HIST_PHOTO_ROLE_LABELS = {
    panoramic: 'Photo panoramique',
    front: 'Face avant',
    back: 'Face arrière'
  };

  function histStatusLabel(s) {
    if (s == null) { return '—'; }
    return HIST_STATUS_LABELS[s] || String(s);
  }
  function histIsHttps(url) {
    return typeof url === 'string' && url.indexOf('https://') === 0;
  }
  function histText(v) {
    if (v === null || v === undefined) { return ''; }
    return String(v);
  }

  /* Formatage FR lisible d'une date serveur ISO. La valeur serveur reste la source :
     en cas d'échec de parse ou d'absence d'Intl, on retombe sur le texte brut. */
  var HIST_MONTHS_FR = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  /* Le jour seul, sans l’heure. La liste nomme la demande par son client et
     n’a besoin que de la date ; l’heure reste dans le détail, où elle sert
     à situer un échange précis. */
  function histFormatDay(v) {
    var raw = histText(v);
    if (!raw) { return ''; }
    var d = new Date(raw);
    if (isNaN(d.getTime())) { return raw; }
    try {
      return new Intl.DateTimeFormat('fr-FR', {
        timeZone: 'Europe/Paris', day: 'numeric', month: 'long', year: 'numeric'
      }).format(d);
    } catch (e) {
      return histFormatDate(v);
    }
  }

  /* Chaque état porte sa teinte : l’avancement d’une demande se repère à la
     couleur avant même d’avoir lu le mot. Un statut inconnu du serveur retombe
     sur la teinte neutre plutôt que de rester sans style. */
  var HIST_STATUS_TONES = {
    submitted: 'neutre',
    under_review: 'status',
    needs_information: 'attention',
    accepted: 'ok',
    approved: 'ok',
    refused: 'refus',
    rejected: 'refus',
    cancelled: 'neutre'
  };

  function histStatusTone(status) {
    var k = histText(status);
    return (k && HIST_STATUS_TONES[k]) ? HIST_STATUS_TONES[k] : 'neutre';
  }

  function histFormatDate(v) {
    var raw = histText(v);
    if (!raw) { return ''; }
    var d = new Date(raw);
    if (isNaN(d.getTime())) { return raw; }
    try {
      var fmt = new Intl.DateTimeFormat('fr-FR', {
        timeZone: 'Europe/Paris',
        day: 'numeric', month: 'long', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: false
      });
      var parts = {};
      var arr = fmt.formatToParts(d);
      for (var i = 0; i < arr.length; i++) { parts[arr[i].type] = arr[i].value; }
      if (parts.day && parts.month && parts.year && parts.hour && parts.minute) {
        return parts.day + ' ' + parts.month + ' ' + parts.year + ' à ' + parts.hour + ':' + parts.minute;
      }
    } catch (e) { /* Intl/timeZone indisponible : fallback local ci-dessous */ }
    // Fallback sans fuseau explicite (heure locale du navigateur).
    var mo = HIST_MONTHS_FR[d.getMonth()] || '';
    var hh = ('0' + d.getHours()).slice(-2);
    var mm = ('0' + d.getMinutes()).slice(-2);
    return d.getDate() + ' ' + mo + ' ' + d.getFullYear() + ' à ' + hh + ':' + mm;
  }

  /* Extraction tolérante d'un tableau d'items depuis diverses formes de réponse. */
  function histExtractItems(body) {
    if (!body) { return []; }
    if (Object.prototype.toString.call(body) === '[object Array]') { return body; }
    var candidates = ['data', 'requests', 'professional_requests', 'items', 'results'];
    for (var i = 0; i < candidates.length; i++) {
      if (Object.prototype.toString.call(body[candidates[i]]) === '[object Array]') {
        return body[candidates[i]];
      }
    }
    return [];
  }
  function histNum(v, dflt) {
    var n = parseInt(v, 10);
    return isNaN(n) ? dflt : n;
  }
  /* Nombre de pages : tolérant (total_pages / last_page, sinon dérivé de total/per_page). */
  function histTotalPages(body, perPage, itemsLen) {
    if (!body) { return 1; }
    var tp = body.total_pages || body.last_page || (body.meta && (body.meta.total_pages || body.meta.last_page));
    tp = histNum(tp, 0);
    if (tp > 0) { return tp; }
    var total = histNum(body.total || (body.meta && body.meta.total), 0);
    if (total > 0 && perPage > 0) { return Math.max(1, Math.ceil(total / perPage)); }
    // Fallback : au moins la page courante ; une page pleine suggère une suivante possible.
    return (itemsLen >= perPage) ? 0 : 1; // 0 = inconnu (bouton suivant géré séparément)
  }
  /* Quantite d'une demande, telle que le serveur l'expose.

     Source UNIQUE : la reponse de l'API. Jamais la valeur du formulaire courant
     — celui-ci decrit une demande en cours de saisie, pas celle qu'on affiche,
     et les confondre ferait lire « 5 exemplaires » sur une demande qui n'en
     comptait qu'un.

     Renvoie null si le champ manque ou n'est pas un entier positif. Le contrat
     v4 expose 1 pour les demandes anterieures, mais une reponse incomplete ou
     tronquee reste possible : on ne fabrique alors aucune quantite, on n'affiche
     rien. Mieux vaut une information absente qu'une information inventee. */
  function histQuantite(source) {
    if (!source || typeof source !== 'object') { return null; }
    var brut = source.quantity;
    if (brut === undefined || brut === null || brut === '') { return null; }
    if (typeof brut === 'boolean') { return null; }
    var n = Number(brut);
    if (!isFinite(n) || Math.floor(n) !== n || n < 1) { return null; }
    return n;
  }

  /* « 1 exemplaire » / « N exemplaires ». */
  function histLibelleQuantite(n) {
    return n + (n > 1 ? ' exemplaires' : ' exemplaire');
  }

  function histPhotosCount(item) {
    if (typeof item.photos_count === 'number') { return item.photos_count; }
    if (Object.prototype.toString.call(item.photos) === '[object Array]') { return item.photos.length; }
    var c = histNum(item.composition, 0);
    return c > 0 ? c : null;
  }

  function initHistory(root) {
    var host = root.querySelector('[data-pp-history]');
    if (!host || host.getAttribute('data-pp-history-initialized') === 'true') { return; }
    host.setAttribute('data-pp-history-initialized', 'true');

    var endpoint = host.getAttribute('data-pp-history-endpoint') || '/apps/partner-portal/professional-requests';
    var perPage = histNum(host.getAttribute('data-pp-history-per-page'), 20);
    if (perPage <= 0) { perPage = 20; }

    var ctrl = {
      host: host,
      endpoint: endpoint,
      perPage: perPage,
      currentPage: 1,
      totalPages: 0,
      // Formulaire de complément (PHO-C) : état courant + bandeau de confirmation.
      // Strictement séparé du formulaire de création (pp-draft-v2).
      complement: null,
      complementNotice: null,
      loadingList: false,
      loadingDetail: false,
      listEl: host.querySelector('[data-pp-history-list]'),
      loadingEl: host.querySelector('[data-pp-history-loading]'),
      emptyEl: host.querySelector('[data-pp-history-empty]'),
      errorEl: host.querySelector('[data-pp-history-error]'),
      paginationEl: host.querySelector('[data-pp-history-pagination]'),
      pageLabelEl: host.querySelector('[data-pp-history-page]'),
      prevBtn: host.querySelector('[data-pp-history-prev]'),
      nextBtn: host.querySelector('[data-pp-history-next]'),
      refreshBtn: host.querySelector('[data-pp-history-refresh]'),
      detailEl: host.querySelector('[data-pp-history-detail]'),
      detailBodyEl: host.querySelector('[data-pp-history-detail-body]'),
      detailCloseBtn: host.querySelector('[data-pp-history-detail-close]')
    };

    if (ctrl.refreshBtn) {
      ctrl.refreshBtn.addEventListener('click', function () { histFetchList(ctrl, ctrl.currentPage); });
    }
    if (ctrl.prevBtn) {
      ctrl.prevBtn.addEventListener('click', function () {
        if (ctrl.currentPage > 1) { histFetchList(ctrl, ctrl.currentPage - 1); }
      });
    }
    if (ctrl.nextBtn) {
      ctrl.nextBtn.addEventListener('click', function () {
        histFetchList(ctrl, ctrl.currentPage + 1);
      });
    }
    if (ctrl.detailCloseBtn) {
      ctrl.detailCloseBtn.addEventListener('click', function () { histCloseDetail(ctrl); });
    }

    // Déclencheur exposé : rafraîchit la liste (page 1) via la fonction fetch existante.
    // Utilisé après une soumission réussie pour refléter la nouvelle demande sans
    // rechargement de page. Réutilise histFetchList (aucun nouveau chemin réseau).
    host.__ppHistoryRefresh = function () { histFetchList(ctrl, 1); };

    histFetchList(ctrl, 1);
  }

  function histSetHidden(el, hidden) { if (el) { el.hidden = !!hidden; } }

  function histShowError(ctrl, msg) {
    if (ctrl.errorEl) {
      ctrl.errorEl.textContent = msg || '';
      ctrl.errorEl.hidden = !msg;
    }
  }

  function histMessageForStatus(status, isDetail) {
    if (status === 401 || status === 403) { return 'Votre accès partenaire n’est pas disponible.'; }
    if (status === 404 && isDetail) { return 'Demande introuvable.'; }
    if (status === 429) { return 'Trop de requêtes, réessayez dans un instant.'; }
    return isDetail
      ? 'Impossible de charger cette demande pour le moment.'
      : 'Impossible de charger vos demandes pour le moment.';
  }

  /* opts.keepDetail : rafraîchit la liste en arrière-plan sans fermer le détail
     ouvert (utilisé après un dépôt de complément). Sans opts, comportement
     historique inchangé. */
  function histFetchList(ctrl, page, opts) {
    if (ctrl.loadingList) { return; }
    if (page < 1) { page = 1; }
    var keepDetail = !!(opts && opts.keepDetail);
    ctrl.loadingList = true;
    if (!keepDetail) {
      histShowError(ctrl, null);
      histSetHidden(ctrl.emptyEl, true);
      histSetHidden(ctrl.loadingEl, false);
      histCloseDetail(ctrl);
    }

    var url = ctrl.endpoint + '?page=' + encodeURIComponent(page) + '&per_page=' + encodeURIComponent(ctrl.perPage);
    window.fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    }).then(function (res) {
      var status = res ? res.status : 0;
      if (status !== 200) {
        histSetHidden(ctrl.loadingEl, true);
        ctrl.loadingList = false;
        // En mode keepDetail, le détail reste la vue active : pas de bandeau
        // d'erreur de liste par-dessus, la liste sera rechargée au retour.
        if (!keepDetail) { histShowError(ctrl, histMessageForStatus(status, false)); }
        return;
      }
      return res.json().then(function (body) {
        histSetHidden(ctrl.loadingEl, true);
        ctrl.loadingList = false;
        var items = histExtractItems(body);
        var serverPage = histNum(body && (body.page || body.current_page || (body.meta && body.meta.current_page)), page);
        ctrl.currentPage = serverPage > 0 ? serverPage : page;
        ctrl.totalPages = histTotalPages(body, ctrl.perPage, items.length);
        histRenderList(ctrl, items);
      }, function () {
        histSetHidden(ctrl.loadingEl, true);
        ctrl.loadingList = false;
        if (!keepDetail) { histShowError(ctrl, histMessageForStatus(0, false)); }
      });
    }).catch(function () {
      histSetHidden(ctrl.loadingEl, true);
      ctrl.loadingList = false;
      if (!keepDetail) { histShowError(ctrl, histMessageForStatus(0, false)); }
    });
  }

  function histRenderList(ctrl, items) {
    if (!ctrl.listEl) { return; }
    ctrl.listEl.textContent = '';
    if (!items || !items.length) {
      histSetHidden(ctrl.emptyEl, false);
      histSetHidden(ctrl.paginationEl, true);
      return;
    }
    histSetHidden(ctrl.emptyEl, true);

    /* Ligne d’en-tête des colonnes. Elle est posée ici et non dans le gabarit
       pour ne pas surmonter une liste vide. Masquée aux lecteurs d’écran : chaque
       ligne énonce déjà son état et son contenu en toutes lettres, l’en-tête ne
       fait que les aligner à l’œil. */
    var entete = document.createElement('li');
    entete.className = 'pp__history-colonnes';
    entete.setAttribute('aria-hidden', 'true');
    var colonnes = ['Demande', 'État', 'Contenu', ''];
    for (var c = 0; c < colonnes.length; c++) {
      var celluleEntete = document.createElement('span');
      celluleEntete.textContent = colonnes[c];
      entete.appendChild(celluleEntete);
    }
    ctrl.listEl.appendChild(entete);

    for (var i = 0; i < items.length; i++) {
      ctrl.listEl.appendChild(histBuildListItem(ctrl, items[i]));
    }
    histRenderPagination(ctrl, items.length);
  }

  function histBuildListItem(ctrl, item) {
    var ref = histText(item.professional_request_reference || item.reference);
    var attention = item.needs_attention === true;
    var jour = histFormatDay(item.submitted_at || item.created_at);

    var li = document.createElement('li');
    li.className = 'pp__history-item' + (attention ? ' pp__history-item--attention' : '');

    /* Colonne 1 — la demande. Elle est nommée par la référence que le partenaire
       a saisie lui-même (« Lampe de Madame Dubois ») : c’est celle-là qu’il
       cherche des yeux, pas notre identifiant, qui ne lui dit rien. L’identifiant
       descend en dernière ligne, en petit — il reste disponible le jour où il faut
       nous parler d’une demande précise.
       Le champ étant facultatif, la date reprend le rôle de titre quand rien n’a
       été saisi : une ligne sans titre serait illisible. */
    var main = document.createElement('div');
    main.className = 'pp__history-item-main';

    var interne = histText(item.partner_internal_reference);
    var titre = document.createElement('p');
    titre.className = 'pp__history-item-client';
    if (interne) {
      titre.textContent = interne;
    } else {
      titre.className += ' pp__history-item-client--absente';
      titre.textContent = 'Demande sans référence';
    }
    main.appendChild(titre);

    /* La date reste en second, en petit, DANS TOUS LES CAS. Elle remontait
       en titre quand aucune référence n’était saisie : la hiérarchie changeait
       alors d’une ligne à l’autre et l’ordre paraissait inversé. Seul le contenu
       du titre varie désormais — jamais sa place. */
    if (jour) {
      var dateEl = document.createElement('p');
      dateEl.className = 'pp__history-item-date';
      dateEl.textContent = 'Envoyée le ' + jour;
      main.appendChild(dateEl);
    }

    if (ref) {
      var refEl = document.createElement('p');
      refEl.className = 'pp__history-item-ref';
      refEl.textContent = ref;
      main.appendChild(refEl);
    }
    li.appendChild(main);

    /* Colonne 2 — l’état, une seule pastille. Le second badge « Action requise »
       disait la même chose que « Complément demandé » juste à côté ; l’urgence est
       désormais portée par la ligne entière, qui se détache du fond. */
    var etat = document.createElement('div');
    etat.className = 'pp__history-item-etat';
    var statusBadge = document.createElement('span');
    statusBadge.className = 'pp__history-badge pp__history-badge--' + histStatusTone(item.status);
    statusBadge.textContent = histStatusLabel(item.status);
    etat.appendChild(statusBadge);
    /* Le paiement est une information distincte de l'avancement de la demande :
       la pastille se pose SOUS celle du statut, jamais à sa place. « Demande
       acceptée » reste donc lisible pendant et après le règlement. */
    var payState = histPaymentState(item);
    if (payState) { etat.appendChild(histPaymentBadge(payState)); }
    li.appendChild(etat);

    /* Colonne 3 — ce que contient la demande. */
    var contenu = document.createElement('div');
    contenu.className = 'pp__history-item-contenu';
    var parts = [];
    /* La quantite vient en tete : c'est ce qui distingue deux demandes par
       ailleurs semblables. Le nombre de photographies la suit, compte a part —
       « 5 exemplaires · 1 photo » decrit cinq lampes tirees d'une seule image,
       et les melanger n'aurait aucun sens. */
    var qte = histQuantite(item);
    if (qte !== null) { parts.push(histLibelleQuantite(qte)); }
    var pc = histPhotosCount(item);
    if (pc !== null) { parts.push(pc + (pc > 1 ? ' photos' : ' photo')); }
    var destLabel = item.shipping && item.shipping.mode ? HIST_DESTINATION_LABELS[item.shipping.mode] : null;
    if (destLabel) { parts.push(destLabel); }
    contenu.textContent = parts.join(' · ');
    li.appendChild(contenu);

    /* Colonne 4 — l’action. Le libellé dit ce qu’il y a à faire, pas ce qu’on
       ouvre : « Répondre » quand l’atelier attend quelque chose, « Voir le détail »
       sinon. */
    var actions = document.createElement('div');
    actions.className = 'pp__history-item-actions';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pp__button pp__button--ghost';
    btn.textContent = attention ? 'Répondre' : 'Voir le détail';
    if (ref) {
      btn.addEventListener('click', function () { histFetchDetail(ctrl, ref); });
    } else {
      btn.disabled = true;
    }
    actions.appendChild(btn);
    /* Le lien de paiement ne vit qu'ici, dans la ligne de SA demande, et lue
       sur cette demande seule : aucune donnée n'est partagée d'une ligne à
       l'autre. Un règlement validé n'en produit aucun. */
    var payLink = histPaymentLink(payState, 'pp__button pp__button--ghost pp__history-item-payment');
    if (payLink) { actions.appendChild(payLink); }
    li.appendChild(actions);

    return li;
  }

  function histRenderPagination(ctrl, itemsLen) {
    if (!ctrl.paginationEl) { return; }
    // Un détail ouvert masque la liste : la pagination reste masquée avec elle
    // (rafraîchissement en arrière-plan après un dépôt de complément).
    if (ctrl.detailEl && ctrl.detailEl.hidden === false) {
      histSetHidden(ctrl.paginationEl, true);
      return;
    }
    var hasPrev = ctrl.currentPage > 1;
    var hasNext;
    if (ctrl.totalPages > 0) {
      hasNext = ctrl.currentPage < ctrl.totalPages;
    } else {
      // Nombre de pages inconnu : proposer "suivant" si la page est pleine.
      hasNext = itemsLen >= ctrl.perPage;
    }
    if (!hasPrev && !hasNext) {
      histSetHidden(ctrl.paginationEl, true);
      return;
    }
    histSetHidden(ctrl.paginationEl, false);
    if (ctrl.prevBtn) { ctrl.prevBtn.disabled = !hasPrev; }
    if (ctrl.nextBtn) { ctrl.nextBtn.disabled = !hasNext; }
    if (ctrl.pageLabelEl) {
      ctrl.pageLabelEl.textContent = ctrl.totalPages > 0
        ? ('Page ' + ctrl.currentPage + ' sur ' + ctrl.totalPages)
        : ('Page ' + ctrl.currentPage);
    }
  }

  function histCloseDetail(ctrl) {
    // Le formulaire de complément quitte la scène avec le détail : les callbacks
    // encore en vol (téléversement, réponse serveur) deviennent inertes.
    ctrl.complement = null;
    if (ctrl.detailEl) { ctrl.detailEl.hidden = true; }
    if (ctrl.detailBodyEl) { ctrl.detailBodyEl.textContent = ''; }
    if (ctrl.listEl) { ctrl.listEl.hidden = false; }
    if (ctrl.paginationEl && (ctrl.currentPage > 1 || ctrl.totalPages > 1 || ctrl.totalPages === 0)) {
      // La visibilité réelle est régie par histRenderPagination ; on laisse l'état courant.
    }
  }

  function histFetchDetail(ctrl, reference) {
    if (ctrl.loadingDetail) { return; }
    ctrl.loadingDetail = true;
    histShowError(ctrl, null);

    var url = ctrl.endpoint + '/' + encodeURIComponent(reference);
    window.fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    }).then(function (res) {
      var status = res ? res.status : 0;
      if (status !== 200) {
        ctrl.loadingDetail = false;
        histShowError(ctrl, histMessageForStatus(status, true));
        return;
      }
      return res.json().then(function (body) {
        ctrl.loadingDetail = false;
        histRenderDetail(ctrl, body);
      }, function () {
        ctrl.loadingDetail = false;
        histShowError(ctrl, histMessageForStatus(0, true));
      });
    }).catch(function () {
      ctrl.loadingDetail = false;
      histShowError(ctrl, histMessageForStatus(0, true));
    });
  }

  /* Petite fabrique : ligne "terme / valeur" (jamais innerHTML). */
  function histDefRow(term, value) {
    var row = document.createElement('div');
    row.className = 'pp__history-detail-row';
    var dt = document.createElement('span');
    dt.className = 'pp__history-detail-term';
    dt.textContent = term;
    var dd = document.createElement('span');
    dd.className = 'pp__history-detail-value';
    dd.textContent = value;
    row.appendChild(dt);
    row.appendChild(dd);
    return row;
  }

  function histRenderDetail(ctrl, data) {
    if (!ctrl.detailBodyEl || !ctrl.detailEl) { return; }
    var d = data && typeof data === 'object' ? (data.data && typeof data.data === 'object' ? data.data : data) : {};
    var body = ctrl.detailBodyEl;
    body.textContent = '';
    // Tout rendu du détail repart d'un formulaire de complément vierge :
    // aucune sélection ni clé d'idempotence ne survit à un changement de demande.
    ctrl.complement = null;

    var ref = histText(d.professional_request_reference || d.reference);
    var title = document.createElement('h3');
    title.className = 'pp__history-detail-title';
    title.textContent = ref || 'Demande';
    body.appendChild(title);

    // Confirmation posée avant ce rechargement (dépôt enregistré, rejeu, cycle périmé).
    histComplementFlushNotice(ctrl, body);

    // Bloc "Action requise" : affiché en tête si le serveur signale un complément
    // (statut needs_information) ou fournit un objet action_required.
    // Rendu 100 % textContent : le motif serveur n'est jamais interprété comme HTML.
    var actionReq = (d.action_required && typeof d.action_required === 'object') ? d.action_required : null;
    if (d.status === 'needs_information' || actionReq) {
      var arBox = document.createElement('div');
      arBox.className = 'pp__history-action-required';

      var arTitle = document.createElement('p');
      arTitle.className = 'pp__history-action-required-title';
      arTitle.textContent = 'Action requise';
      arBox.appendChild(arTitle);

      var arLead = document.createElement('p');
      arLead.className = 'pp__history-action-required-lead';
      arLead.textContent = 'Nous avons besoin d’un complément pour poursuivre l’étude de votre demande.';
      arBox.appendChild(arLead);

      var reason = actionReq ? histText(actionReq.reason) : '';
      if (reason) {
        var arReason = document.createElement('p');
        arReason.className = 'pp__history-action-required-reason';
        arReason.textContent = reason;
        arBox.appendChild(arReason);
      } else {
        var arFallback = document.createElement('p');
        arFallback.className = 'pp__history-action-required-reason';
        arFallback.textContent = 'Un complément d’information est nécessaire. Notre équipe vous précisera les éléments attendus.';
        arBox.appendChild(arFallback);
      }

      var reqAt = actionReq ? histFormatDate(actionReq.requested_at) : '';
      if (reqAt) {
        var arDate = document.createElement('p');
        arDate.className = 'pp__history-action-required-date';
        arDate.textContent = 'Demandé le ' + reqAt;
        arBox.appendChild(arDate);
      }

      body.appendChild(arBox);
    }

    // Dépôt de complément — directement sous le bloc « Action requise ».
    // N'affiche rien si le serveur n'a pas ouvert de cycle exploitable.
    histComplementRender(ctrl, body, d, actionReq);

    // Paiement à effectuer — juste sous le complément, avant le récapitulatif.
    // Le lien n'apparaît qu'ici : jamais dans la liste des demandes, jamais
    // dans les lignes « terme / valeur ».
    histPaymentRender(body, d);

    var list = document.createElement('div');
    list.className = 'pp__history-detail-list';

    var statusBadge = document.createElement('span');
    statusBadge.className = 'pp__history-badge pp__history-badge--' + histStatusTone(d.status);
    statusBadge.textContent = histStatusLabel(d.status);
    var statusRow = histDefRow('Statut', '');
    statusRow.querySelector('.pp__history-detail-value').appendChild(statusBadge);
    list.appendChild(statusRow);

    var submitted = d.submitted_at || d.created_at;
    if (submitted) { list.appendChild(histDefRow('Envoyée le', histFormatDate(submitted))); }
    /* Nombre d'exemplaires — lu sur le detail servi, jamais sur le formulaire.
       Ligne omise si le serveur ne l'expose pas : aucune valeur par defaut. */
    var qteDetail = histQuantite(d);
    if (qteDetail !== null) {
      list.appendChild(histDefRow('Nombre d\u2019exemplaires', histLibelleQuantite(qteDetail)));
    }
    if (d.composition !== undefined && d.composition !== null && HIST_COMPOSITION_LABELS[d.composition]) {
      list.appendChild(histDefRow('Composition', HIST_COMPOSITION_LABELS[d.composition]));
    }
    if (d.base_color) { list.appendChild(histDefRow('Couleur du socle', histText(d.base_color))); }
    var mode = d.shipping && d.shipping.mode;
    if (mode && HIST_DESTINATION_LABELS[mode]) {
      list.appendChild(histDefRow('Destination', HIST_DESTINATION_LABELS[mode]));
    }
    if (d.partner_internal_reference) {
      list.appendChild(histDefRow('Référence de dossier', histText(d.partner_internal_reference)));
    }
    var cust = d.customization || {};
    if (cust.text) { list.appendChild(histDefRow('Texte personnalisé', histText(cust.text))); }
    if (cust.instructions) { list.appendChild(histDefRow('Instructions', histText(cust.instructions))); }
    body.appendChild(list);

    // Photos (rôle FR + nom + miniature si cdn_url HTTPS)
    var photos = Object.prototype.toString.call(d.photos) === '[object Array]' ? d.photos : [];
    if (photos.length) {
      var photosTitle = document.createElement('h4');
      photosTitle.className = 'pp__history-detail-subtitle';
      photosTitle.textContent = 'Photographies';
      body.appendChild(photosTitle);

      var photosWrap = document.createElement('div');
      photosWrap.className = 'pp__history-photos';
      for (var p = 0; p < photos.length; p++) {
        photosWrap.appendChild(histBuildPhoto(photos[p]));
      }
      body.appendChild(photosWrap);
    }

    // Historique des statuts (from_status → to_status + date).
    // Clé serveur prioritaire : status_history ; fallback tolérant : history.
    var isArr = function (v) { return Object.prototype.toString.call(v) === '[object Array]'; };
    var hist = isArr(d.status_history) ? d.status_history : (isArr(d.history) ? d.history : []);
    if (hist.length) {
      var histTitle = document.createElement('h4');
      histTitle.className = 'pp__history-detail-subtitle';
      histTitle.textContent = 'Suivi';
      body.appendChild(histTitle);

      var ul = document.createElement('ul');
      ul.className = 'pp__history-timeline';
      for (var h = 0; h < hist.length; h++) {
        var ev = hist[h] || {};
        var liH = document.createElement('li');
        liH.className = 'pp__history-timeline-item';
        // Première entrée sans statut précédent : afficher uniquement le statut atteint
        // (jamais « — → Envoyée »). Transitions normales : « Envoyée → En cours d'étude ».
        var hasFrom = ev.from_status !== null && ev.from_status !== undefined && ev.from_status !== '';
        var toLabel = histStatusLabel(ev.to_status);
        var transition = hasFrom ? (histStatusLabel(ev.from_status) + ' → ' + toLabel) : toLabel;
        var when = ev.created_at || ev.at || ev.date;
        liH.textContent = when ? (transition + ' · ' + histFormatDate(when)) : transition;
        ul.appendChild(liH);
      }
      body.appendChild(ul);
    }

    if (ctrl.listEl) { ctrl.listEl.hidden = true; }
    histSetHidden(ctrl.paginationEl, true);
    ctrl.detailEl.hidden = false;
    if (typeof ctrl.detailEl.focus === 'function') { ctrl.detailEl.focus(); }
  }

  /* ---------- paiement (socle commun liste + détail) ----------

     Le portail n'a aucune autorité sur le paiement : il ne fait que dire ce que
     le serveur nomme. Il ne déduit jamais « payé » d'un clic, d'un statut de
     demande, d'une date ou d'un montant, et ne déclenche aucun passage en
     production — cette bascule appartient au backend, après l'événement
     Shopify correspondant. */

  var HIST_PAYMENT_LABELS = {
    pending: 'Paiement à effectuer',
    paid: 'Paiement validé'
  };
  var HIST_PAYMENT_LINK_LABEL = 'Ouvrir le lien de paiement';

  /* État de paiement exploitable, ou null quand il n'y a rien à montrer.
     - payment.status === 'paid'          → règlement reçu, plus aucun lien.
     - payment.status === 'pending'       → règlement attendu ; le lien n'est
       retenu que si has_payment_link est STRICTEMENT vrai et l'URL commence
       exactement par https://.
     - status absent                      → contrat antérieur (l'ERP ne posait
       pas encore le champ) : traité comme 'pending', sous les mêmes conditions
       de lien. Aucune demande déjà réglée n'est concernée, un paiement reçu
       étant toujours nommé.
     - tout autre état nommé par le serveur (refunded, expired, cancelled…)
       → rien du tout : le thème n'affiche pas un état qu'il ne connaît pas. */
  function histPaymentState(source) {
    var pay = (source && source.payment && typeof source.payment === 'object') ? source.payment : null;
    if (!pay) { return null; }

    var status = histText(pay.status);
    if (status === 'paid') { return { status: 'paid', link: null }; }
    if (status !== 'pending' && status !== '') { return null; }

    if (pay.has_payment_link !== true) { return null; }
    if (!histIsHttps(pay.payment_link)) { return null; }
    return { status: 'pending', link: pay.payment_link };
  }

  /* Pastille d'état du paiement.
     Un règlement attendu n'est ni une alerte ni un refus : il porte sa propre
     classe dorée (--paiement) et jamais --attention, réservée au complément
     demandé, ni --refus, réservée aux demandes refusées. Le vert --ok marque
     le règlement reçu, comme il marque déjà une demande acceptée. */
  function histPaymentBadge(state) {
    var badge = document.createElement('span');
    badge.className = 'pp__history-badge pp__history-badge--'
      + (state.status === 'paid' ? 'ok' : 'paiement');
    badge.textContent = HIST_PAYMENT_LABELS[state.status];
    return badge;
  }

  /* Lien de paiement, ou null. Un règlement reçu n'en produit jamais :
     le lien disparaît de lui-même dès que le serveur annonce « paid ».
     Construit en DOM (createElement / setAttribute / textContent) : jamais
     d'innerHTML, donc jamais de balise venue du serveur. */
  function histPaymentLink(state, className) {
    if (!state || state.status !== 'pending' || !state.link) { return null; }
    var link = document.createElement('a');
    link.className = className;
    link.setAttribute('href', state.link);
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
    link.textContent = HIST_PAYMENT_LINK_LABEL;
    return link;
  }

  /* Bloc paiement du détail — « Paiement à effectuer » ou « Paiement validé ».
     Aucun montant calculé ici, aucun statut changé, aucun appel supplémentaire. */
  function histPaymentRender(body, d) {
    var state = histPaymentState(d);
    if (!state) { return; }
    var paid = state.status === 'paid';

    var box = document.createElement('div');
    box.className = 'pp__history-action-required pp__history-payment'
      + (paid ? ' pp__history-payment--paid' : '');

    var title = document.createElement('p');
    title.className = 'pp__history-action-required-title';
    title.textContent = HIST_PAYMENT_LABELS[state.status];
    box.appendChild(title);

    var lead = document.createElement('p');
    lead.className = 'pp__history-action-required-lead';
    lead.textContent = paid
      ? 'Votre règlement a bien été enregistré. Aucune action de votre part n’est nécessaire.'
      : 'Votre demande est prête pour le règlement. Le paiement s’effectue sur une page sécurisée, dans un nouvel onglet.';
    box.appendChild(lead);

    var link = histPaymentLink(state, 'pp__btn pp__history-payment-link');
    if (link) { box.appendChild(link); }

    body.appendChild(box);
  }

  function histBuildPhoto(photo) {
    var p = photo || {};
    var card = document.createElement('div');
    card.className = 'pp__history-photo';

    if (histIsHttps(p.cdn_url)) {
      var img = document.createElement('img');
      img.className = 'pp__history-photo-img';
      // src via propriété (jamais innerHTML) + variation Uploadcare d'aperçu.
      // `preview` met à l'échelle DANS la boîte sans jamais rogner : le ratio
      // d'origine est conservé. Aucune dimension fixe n'est imposée ici,
      // c'est la CSS qui borne l'aperçu.
      img.src = p.cdn_url + '-/preview/640x640/-/quality/smart/';
      img.loading = 'lazy';
      img.setAttribute('alt', HIST_PHOTO_ROLE_LABELS[p.role] || 'Photographie');

      // Clic : ouverture de l'original en grand, par le même mécanisme que le
      // lien de paiement (ancre DOM, nouvel onglet, rel noopener noreferrer).
      var imgLink = document.createElement('a');
      imgLink.className = 'pp__history-photo-link';
      imgLink.setAttribute('href', p.cdn_url);
      imgLink.setAttribute('target', '_blank');
      imgLink.setAttribute('rel', 'noopener noreferrer');
      imgLink.setAttribute('title', 'Ouvrir la photographie en grand');
      imgLink.appendChild(img);
      card.appendChild(imgLink);
    }

    var caption = document.createElement('p');
    caption.className = 'pp__history-photo-caption';
    var roleLabel = HIST_PHOTO_ROLE_LABELS[p.role] || histText(p.role) || 'Photographie';
    caption.textContent = roleLabel;
    if (p.name) {
      // Nom borné (ellipse via CSS) ; nom complet accessible via title.
      caption.appendChild(document.createTextNode(' · '));
      var nameEl = document.createElement('span');
      nameEl.className = 'pp__history-photo-name';
      nameEl.textContent = histText(p.name);
      nameEl.setAttribute('title', histText(p.name));
      caption.appendChild(nameEl);
    }
    card.appendChild(caption);

    return card;
  }

  /* ============================================================
     PHO-C — Dépôt de complément photographique (statut « Complément demandé »)
     Greffé sous le bloc « Action requise » du détail d'une demande.
     - Module isolé : aucun état partagé avec le formulaire de création
       (schéma pp-draft-v2). Aucun stockage navigateur, aucun secret.
     - Rendu 100 % createElement/textContent : aucun contenu serveur n'est
       jamais interprété comme du HTML.
     - Le navigateur n'est jamais autoritaire : il ne propose le dépôt que
       si le serveur a renvoyé needs_information ET un cycle_token exploitable.
       Le backend revalide tout, y compris le jeton et la transition.
     - Aucune identité partenaire, aucun brand_id, aucun statut cible :
       le payload ne porte que le jeton de cycle, les rôles remplacés et
       un message facultatif.
     ============================================================ */
  var COMPLEMENT_SCHEMA = 'pp-complement-v1';
  var COMPLEMENT_SOURCE = 'partner_portal';
  var COMPLEMENT_MESSAGE_MAX = 1000;
  var COMPLEMENT_MESSAGE_THRESHOLD = 920;
  var COMPLEMENT_ROLE_ORDER = ['panoramic', 'front', 'back'];
  var COMPLEMENT_UNAVAILABLE =
    'Le dépôt de complément n’est pas disponible pour cette demande. Répondez au message de l’atelier pour transmettre vos éléments.';
  var complementSeq = 0;

  /* Jeton de cycle — contrat backend livré : exactement 32 caractères hexadécimaux
     minuscules. Aucune tolérance élargie : un jeton malformé ferme le dépôt.
     Le jeton est retransmis tel quel, sans trim ni normalisation. */
  var COMPLEMENT_TOKEN_RE = /^[0-9a-f]{32}$/;
  function histValidCycleToken(v) {
    return typeof v === 'string' && COMPLEMENT_TOKEN_RE.test(v);
  }

  /* Rôles remplaçables d'une demande existante.

     Un complément remplace des photographies DANS la disposition déjà
     enregistrée : il ne la change jamais, et photo_layout est interdit dans son
     payload (contrat v3, §4). Les rôles admis sont donc ceux de cette
     disposition, dans l'ordre d'affichage.

     Trois sources, de la plus sûre à la plus ancienne :

       1. d.photo_layout — depuis v3, le serveur l'expose. Source d'autorité :
          sur front_only, seul front est remplaçable, même si une demande mal
          formée portait d'autres photos.
       2. les rôles réellement présents dans d.photos — pour les demandes
          antérieures à v3, où photo_layout vaut null.
       3. la composition seule — dernier recours, pour une demande ancienne dont
          le détail ne porterait pas encore ses photos.

     Le navigateur n'est jamais autoritaire : le serveur revalide la liste. */
  function histComplementRoles(d) {
    var out = [], seen = {}, i, r;

    if (isLayout(d.photo_layout)) {
      return rolesForLayout(d.photo_layout);
    }

    var photos = Object.prototype.toString.call(d.photos) === '[object Array]' ? d.photos : [];
    for (i = 0; i < photos.length; i++) {
      r = photos[i] && photos[i].role;
      if (COMPLEMENT_ROLE_ORDER.indexOf(r) !== -1 && !seen[r]) { seen[r] = true; out.push(r); }
    }
    if (!out.length) { out = rolesForMode(histNum(d.composition, 0)); }
    out.sort(function (a, b) {
      return COMPLEMENT_ROLE_ORDER.indexOf(a) - COMPLEMENT_ROLE_ORDER.indexOf(b);
    });
    return out;
  }

  /* Photo actuelle par rôle (première occurrence retenue). */
  function histComplementCurrent(d) {
    var map = {};
    var photos = Object.prototype.toString.call(d.photos) === '[object Array]' ? d.photos : [];
    for (var i = 0; i < photos.length; i++) {
      var p = photos[i] || {};
      if (COMPLEMENT_ROLE_ORDER.indexOf(p.role) !== -1 && !map[p.role]) { map[p.role] = p; }
    }
    return map;
  }

  /* Clé publique Uploadcare et limite de taille : portées par le bloc historique,
     sinon reprises du formulaire de création de la même racine portail.
     La clé publique Uploadcare est publique par construction — jamais un secret. */
  function histComplementAttr(ctrl, name) {
    var host = ctrl.host;
    var v = host.getAttribute(name);
    if (v) { return v; }
    var portal = host.closest ? host.closest('[data-pp-root]') : null;
    var req = portal ? portal.querySelector('[data-pp-request]') : null;
    return req ? (req.getAttribute(name) || '') : '';
  }

  function histComplementUnavailable(body) {
    var na = document.createElement('p');
    na.className = 'pp__complement-unavailable';
    na.textContent = COMPLEMENT_UNAVAILABLE;
    body.appendChild(na);
  }

  /* Bandeau posé avant un rechargement du détail (succès, rejeu, cycle périmé). */
  function histComplementFlushNotice(ctrl, body) {
    var n = ctrl.complementNotice;
    ctrl.complementNotice = null;
    if (!n || !n.text) { return; }
    var p = document.createElement('p');
    p.className = 'pp__complement-notice' + (n.tone === 'success' ? ' pp__complement-notice--success' : '');
    p.setAttribute('role', 'status');
    p.textContent = n.text;
    body.appendChild(p);
  }

  /* ---------- rendu du formulaire ---------- */
  function histComplementRender(ctrl, body, d, actionReq) {
    if (d.status !== 'needs_information') { return; }

    var token = actionReq ? actionReq.cycle_token : null;
    if (!histValidCycleToken(token)) {
      // Motif conservé au-dessus. Indication sobre, aucun formulaire, aucun faux succès.
      histComplementUnavailable(body);
      return;
    }

    var reference = histText(d.professional_request_reference || d.reference);
    var roles = histComplementRoles(d);
    if (!reference || !roles.length) {
      histComplementUnavailable(body);
      return;
    }

    var c = {
      ctrl: ctrl,
      reference: reference,
      cycleToken: token,
      roles: roles,
      current: histComplementCurrent(d),
      selected: {},
      slotEls: {},
      message: '',
      busy: false,
      submitting: false,
      idemKey: null,
      idemSignature: null,
      publicKey: histComplementAttr(ctrl, 'data-pp-uploadcare-public-key'),
      maxFileBytes: histNum(histComplementAttr(ctrl, 'data-pp-max-file-bytes'), 26214400)
    };
    if (c.maxFileBytes <= 0) { c.maxFileBytes = 26214400; }
    ctrl.complement = c;

    var wrap = document.createElement('div');
    wrap.className = 'pp__complement';
    wrap.setAttribute('data-pp-complement', '');

    var title = document.createElement('h4');
    title.className = 'pp__complement-title';
    title.textContent = 'Déposer mon complément';
    wrap.appendChild(title);

    var intro = document.createElement('p');
    intro.className = 'pp__complement-intro';
    intro.textContent = roles.length > 1
      ? 'Remplacez une photographie ou les deux, ajoutez un message si nécessaire, puis envoyez votre complément sur cette même demande.'
      : 'Remplacez la photographie, ajoutez un message si nécessaire, puis envoyez votre complément sur cette même demande.';
    wrap.appendChild(intro);

    var slots = document.createElement('div');
    slots.className = 'pp__complement-slots';
    for (var i = 0; i < roles.length; i++) {
      slots.appendChild(histComplementBuildSlot(c, roles[i]));
    }
    wrap.appendChild(slots);

    /* Message facultatif — 1000 caractères, comptés en points de code. */
    var field = document.createElement('div');
    field.className = 'pp__complement-field';
    var msgId = 'pp-complement-message-' + (++complementSeq);

    var label = document.createElement('label');
    label.className = 'pp__label';
    label.setAttribute('for', msgId);
    label.textContent = 'Message pour l’atelier (facultatif)';
    field.appendChild(label);

    var ta = document.createElement('textarea');
    ta.className = 'pp__textarea pp__complement-message';
    ta.id = msgId;
    ta.rows = 4;
    ta.maxLength = COMPLEMENT_MESSAGE_MAX;
    ta.setAttribute('aria-describedby', msgId + '-counter');
    field.appendChild(ta);

    var counter = document.createElement('p');
    counter.className = 'pp__counter';
    counter.id = msgId + '-counter';
    counter.setAttribute('aria-live', 'polite');
    counter.setAttribute('aria-label', '0 caractères sur ' + COMPLEMENT_MESSAGE_MAX);
    counter.textContent = '0 / ' + COMPLEMENT_MESSAGE_MAX;
    field.appendChild(counter);

    var msgErr = document.createElement('p');
    msgErr.className = 'pp__field-error';
    msgErr.hidden = true;
    field.appendChild(msgErr);
    wrap.appendChild(field);

    c.messageEl = ta;
    c.messageErrorEl = msgErr;
    ta.addEventListener('input', function () {
      c.message = ta.value;
      var len = codePointLength(ta.value);
      counter.textContent = len + ' / ' + COMPLEMENT_MESSAGE_MAX;
      counter.setAttribute('aria-label', len + ' caractères sur ' + COMPLEMENT_MESSAGE_MAX);
      counter.classList.toggle('pp__counter--warning', len >= COMPLEMENT_MESSAGE_THRESHOLD);
      histComplementMessageError(c, null);
      histComplementRefreshControls(c);
    });

    var err = document.createElement('p');
    err.className = 'pp__complement-error';
    err.setAttribute('role', 'alert');
    err.hidden = true;
    wrap.appendChild(err);
    c.errorEl = err;

    var statusEl = document.createElement('p');
    statusEl.className = 'pp__complement-status';
    statusEl.setAttribute('role', 'status');
    statusEl.setAttribute('aria-live', 'polite');
    wrap.appendChild(statusEl);
    c.statusEl = statusEl;

    var submitBtn = document.createElement('button');
    submitBtn.type = 'button';
    submitBtn.className = 'pp__button pp__button--submit pp__complement-submit';
    submitBtn.textContent = 'Envoyer mon complément';
    submitBtn.addEventListener('click', function () { histComplementSubmit(c); });
    wrap.appendChild(submitBtn);
    c.submitBtn = submitBtn;

    body.appendChild(wrap);

    if (!c.publicKey) {
      histComplementError(c, 'Le service d’ajout de photographies est momentanément indisponible. Réessayez plus tard.');
    }
    histComplementRefreshControls(c);
  }

  /* ---------- une zone de remplacement (photo actuelle + nouvelle sélection) ---------- */
  function histComplementBuildSlot(c, role) {
    var roleLabel = HIST_PHOTO_ROLE_LABELS[role] || role;

    var wrap = document.createElement('div');
    wrap.className = 'pp__complement-slot';

    var head = document.createElement('p');
    head.className = 'pp__complement-slot-title';
    head.textContent = roleLabel;
    wrap.appendChild(head);

    // Photo actuelle — clairement identifiée, jamais confondue avec la nouvelle.
    var cur = document.createElement('div');
    cur.className = 'pp__complement-photo pp__complement-photo--current';
    var curPhoto = c.current[role] || {};
    if (histIsHttps(curPhoto.cdn_url)) {
      var curImg = document.createElement('img');
      curImg.className = 'pp__complement-thumb';
      curImg.src = curPhoto.cdn_url + '-/preview/160x160/-/quality/smart/';
      curImg.loading = 'lazy';
      curImg.width = 72;
      curImg.height = 72;
      curImg.setAttribute('alt', 'Photographie actuelle — ' + roleLabel);
      cur.appendChild(curImg);
    }
    var curCap = document.createElement('p');
    curCap.className = 'pp__complement-caption';
    var curTag = document.createElement('span');
    curTag.className = 'pp__complement-tag';
    curTag.textContent = 'Photo actuelle';
    curCap.appendChild(curTag);
    if (curPhoto.name) {
      curCap.appendChild(document.createTextNode(' · '));
      var curName = document.createElement('span');
      curName.className = 'pp__complement-name';
      curName.textContent = histText(curPhoto.name);
      curName.setAttribute('title', histText(curPhoto.name));
      curCap.appendChild(curName);
    }
    cur.appendChild(curCap);
    wrap.appendChild(cur);

    // Nouvelle photographie — aperçu + retrait possible avant envoi.
    var next = document.createElement('div');
    next.className = 'pp__complement-photo pp__complement-photo--new';
    next.hidden = true;
    var nextImg = document.createElement('img');
    nextImg.className = 'pp__complement-thumb';
    nextImg.loading = 'lazy';
    nextImg.width = 72;
    nextImg.height = 72;
    nextImg.setAttribute('alt', 'Nouvelle photographie — ' + roleLabel);
    next.appendChild(nextImg);
    var nextCap = document.createElement('p');
    nextCap.className = 'pp__complement-caption';
    next.appendChild(nextCap);
    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'pp__button pp__button--ghost pp__complement-remove';
    removeBtn.textContent = 'Retirer cette sélection';
    removeBtn.addEventListener('click', function () { histComplementRemove(c, role); });
    next.appendChild(removeBtn);
    wrap.appendChild(next);

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'pp__button pp__button--upload pp__complement-add';
    addBtn.textContent = 'Remplacer cette photographie';
    addBtn.addEventListener('click', function () { histComplementAdd(c, role); });
    wrap.appendChild(addBtn);

    var err = document.createElement('p');
    err.className = 'pp__field-error pp__complement-slot-error';
    err.hidden = true;
    wrap.appendChild(err);

    c.slotEls[role] = {
      wrap: wrap, next: next, nextImg: nextImg, nextCap: nextCap,
      addBtn: addBtn, removeBtn: removeBtn, error: err
    };
    return wrap;
  }

  function histComplementPaintSlot(c, role) {
    var els = c.slotEls[role];
    if (!els) { return; }
    var sel = c.selected[role];
    if (!sel) {
      els.next.hidden = true;
      els.nextImg.removeAttribute('src');
      els.nextCap.textContent = '';
      els.addBtn.textContent = 'Remplacer cette photographie';
      els.wrap.classList.remove('pp__complement-slot--replaced');
      return;
    }
    if (histIsHttps(sel.cdn_url)) {
      els.nextImg.src = sel.cdn_url + '-/preview/160x160/-/quality/smart/';
      els.nextImg.hidden = false;
    } else {
      els.nextImg.removeAttribute('src');
      els.nextImg.hidden = true;
    }
    els.nextCap.textContent = '';
    var tag = document.createElement('span');
    tag.className = 'pp__complement-tag pp__complement-tag--new';
    tag.textContent = 'Nouvelle photo';
    els.nextCap.appendChild(tag);
    if (sel.name) {
      els.nextCap.appendChild(document.createTextNode(' · '));
      var nameEl = document.createElement('span');
      nameEl.className = 'pp__complement-name';
      nameEl.textContent = sel.name;
      nameEl.setAttribute('title', sel.name);
      els.nextCap.appendChild(nameEl);
    }
    els.next.hidden = false;
    els.addBtn.textContent = 'Choisir une autre photographie';
    els.wrap.classList.add('pp__complement-slot--replaced');
  }

  /* Rôles effectivement remplacés, dans un ordre stable (signature déterministe). */
  function histComplementSelectedRoles(c) {
    var out = [];
    for (var i = 0; i < COMPLEMENT_ROLE_ORDER.length; i++) {
      var r = COMPLEMENT_ROLE_ORDER[i];
      if (c.roles.indexOf(r) !== -1 && c.selected[r]) { out.push(r); }
    }
    return out;
  }

  /* Une seule opération à la fois : téléversement OU envoi, jamais les deux. */
  function histComplementRefreshControls(c) {
    var locked = c.busy || c.submitting;
    for (var i = 0; i < c.roles.length; i++) {
      var els = c.slotEls[c.roles[i]];
      if (!els) { continue; }
      var addBlocked = locked || !c.publicKey;
      els.addBtn.disabled = addBlocked;
      els.addBtn.setAttribute('aria-disabled', addBlocked ? 'true' : 'false');
      els.addBtn.classList.toggle('pp__button--disabled', addBlocked);
      els.removeBtn.disabled = locked;
    }
    if (c.messageEl) { c.messageEl.disabled = c.submitting; }
    if (c.submitBtn) {
      var ok = !locked && histComplementSelectedRoles(c).length > 0;
      c.submitBtn.disabled = !ok;
      c.submitBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
      c.submitBtn.classList.toggle('pp__button--disabled', !ok);
      c.submitBtn.textContent = c.submitting ? 'Envoi en cours…' : 'Envoyer mon complément';
    }
  }

  function histComplementStatus(c, msg) {
    if (c.statusEl) { c.statusEl.textContent = msg || ''; }
  }
  function histComplementError(c, msg) {
    if (!c.errorEl) { return; }
    c.errorEl.textContent = msg || '';
    c.errorEl.hidden = !msg;
  }
  function histComplementSlotError(c, role, msg) {
    var els = c.slotEls[role];
    if (!els) { return; }
    els.error.textContent = msg || '';
    els.error.hidden = !msg;
  }
  function histComplementMessageError(c, msg) {
    if (!c.messageErrorEl) { return; }
    c.messageErrorEl.textContent = msg || '';
    c.messageErrorEl.hidden = !msg;
  }
  function histComplementClearErrors(c) {
    histComplementError(c, null);
    histComplementMessageError(c, null);
    for (var i = 0; i < c.roles.length; i++) { histComplementSlotError(c, c.roles[i], null); }
  }

  /* Un formulaire n'est « courant » que tant qu'il est celui du détail affiché.
     Dès qu'on revient à la liste ou qu'on ouvre une autre demande, ctrl.complement
     change : tout callback tardif (téléversement ou réponse serveur) devient inerte
     et ne peut donc jamais s'appliquer à une autre demande. */
  function histComplementIsCurrent(c) {
    return !!(c && c.ctrl && c.ctrl.complement === c);
  }

  function histComplementUnlock(c) {
    c.busy = false;
    if (!histComplementIsCurrent(c)) { return; }
    histComplementStatus(c, '');
    histComplementRefreshControls(c);
  }

  /* ---------- sélection d'une nouvelle photographie (widget Uploadcare existant) ---------- */
  function histComplementAdd(c, role) {
    if (c.busy || c.submitting) { return; }
    histComplementSlotError(c, role, null);
    if (!c.publicKey) {
      histComplementSlotError(c, role, 'Service d’ajout de photographies temporairement indisponible.');
      return;
    }

    c.busy = true;
    histComplementRefreshControls(c);
    histComplementStatus(c, 'Ouverture du sélecteur…');

    var maxBytes = c.maxFileBytes;
    loadUploadcare().then(function (uc) {
      var dialog = uc.openDialog(null, {
        publicKey: c.publicKey,
        imagesOnly: true,
        locale: 'fr',
        clearable: false,
        multiple: false,
        validators: [function (fileInfo) {
          if (fileInfo && fileInfo.size !== null && typeof fileInfo.size === 'number' &&
              fileInfo.size > maxBytes) {
            throw new Error('fileMaximumSize');
          }
        }]
      });
      dialog.done(function (fileObj) {
        histComplementStatus(c, 'Téléversement en cours…');
        fileObj.promise().then(function (info) {
          histComplementApply(c, role, info);
        }, function () {
          histComplementUnlock(c);
          histComplementSlotError(c, role, 'Impossible d’ajouter cette photographie. Réessayez.');
        });
      });
      if (typeof dialog.fail === 'function') {
        dialog.fail(function () {
          // Annulation : aucune erreur trompeuse, sélection précédente conservée.
          histComplementUnlock(c);
        });
      }
    }).catch(function () {
      histComplementUnlock(c);
      histComplementSlotError(c, role, 'Service d’ajout indisponible pour le moment. Réessayez.');
    });
  }

  function histComplementApply(c, role, info) {
    c.busy = false;
    // Téléversement terminé après un retour à la liste ou l'ouverture d'une autre
    // demande : la sélection est abandonnée, jamais reportée ailleurs.
    if (!histComplementIsCurrent(c)) { return; }

    var name = info && info.name ? String(info.name) : '';
    var size = info && typeof info.size === 'number' ? info.size : null;

    var ext = extOf(name);
    if (ext && ALLOWED_EXT.indexOf(ext) === -1) {
      histComplementUnlock(c);
      histComplementSlotError(c, role, 'Format non accepté. Utilisez JPG, JPEG, PNG ou WEBP.');
      return;
    }
    if (size !== null && size > c.maxFileBytes) {
      histComplementUnlock(c);
      histComplementSlotError(c, role, 'Le fichier dépasse la limite de ' + formatBytes(c.maxFileBytes) + '.');
      return;
    }

    var uuid = info && info.uuid ? String(info.uuid) : '';
    var cdn = info && info.cdnUrl ? String(info.cdnUrl) : '';
    if (!uuid || !histIsHttps(cdn)) {
      histComplementUnlock(c);
      histComplementSlotError(c, role, 'Cette photographie n’a pas pu être préparée. Réessayez.');
      return;
    }

    // Remplacement retenu seulement après succès complet du nouveau fichier.
    c.selected[role] = { role: role, uuid: uuid, cdn_url: cdn, name: name, size: size };
    histComplementSlotError(c, role, null);
    histComplementError(c, null);
    histComplementPaintSlot(c, role);
    histComplementStatus(c, 'Photographie prête à être envoyée.');
    histComplementRefreshControls(c);
  }

  function histComplementRemove(c, role) {
    if (c.busy || c.submitting) { return; }
    delete c.selected[role];
    histComplementSlotError(c, role, null);
    histComplementPaintSlot(c, role);
    histComplementStatus(c, 'Sélection retirée.');
    histComplementRefreshControls(c);
  }

  /* ---------- payload + clé d'idempotence ---------- */
  function histComplementPayload(c) {
    var roles = histComplementSelectedRoles(c);
    var photos = [];
    for (var i = 0; i < roles.length; i++) {
      var s = c.selected[roles[i]];
      photos.push({
        role: roles[i],
        uuid: s.uuid,
        cdn_url: s.cdn_url,
        name: s.name ? s.name : null
      });
    }
    /* Aucun photo_layout ici, jamais : le serveur le refuse (prohibited) sur un
       complément. Une demande garde la disposition qu'elle avait à sa création ;
       la changer serait une autre demande. Aucun model_size, aucun champ
       tarifaire non plus. */
    return {
      schema_version: COMPLEMENT_SCHEMA,
      source: COMPLEMENT_SOURCE,
      cycle_token: c.cycleToken,
      photos: photos,
      message: trimOrNull(c.message)
    };
  }

  /* Une clé par soumission, définie par son contenu : un réessai à contenu
     identique conserve exactement la même clé (jamais régénérée au clic). */
  function histComplementKey(c, signature) {
    if (!c.idemKey || c.idemSignature !== signature) {
      c.idemKey = uuidV4();
      c.idemSignature = signature;
    }
    return c.idemKey;
  }

  /* Code d'erreur serveur, lecture tolérante (jamais interprété comme HTML). */
  function histComplementCode(body) {
    if (!body || typeof body !== 'object') { return ''; }
    var direct = body.code || body.error_code || body.error || body.reason;
    if (typeof direct === 'string') { return direct; }
    if (Object.prototype.toString.call(body.errors) === '[object Array]') {
      for (var i = 0; i < body.errors.length; i++) {
        var e = body.errors[i];
        if (e && typeof e.code === 'string') { return e.code; }
      }
    }
    return '';
  }

  /* ---------- envoi ---------- */
  function histComplementSubmit(c) {
    var ctrl = c.ctrl;
    if (c.submitting || c.busy) { return; }

    var roles = histComplementSelectedRoles(c);
    if (!roles.length) {
      histComplementError(c, 'Ajoutez au moins une nouvelle photographie avant l’envoi.');
      return;
    }
    if (codePointLength(c.message) > COMPLEMENT_MESSAGE_MAX) {
      histComplementMessageError(c, 'Message limité à ' + COMPLEMENT_MESSAGE_MAX + ' caractères.');
      return;
    }

    var payload = histComplementPayload(c);
    var signature = null;
    try { signature = JSON.stringify(payload); } catch (e) { signature = null; }
    var key = histComplementKey(c, signature);
    if (!key) {
      histComplementError(c, 'Impossible de préparer l’envoi sécurisé sur ce navigateur. Réessayez.');
      return;
    }

    histComplementClearErrors(c);
    c.submitting = true;
    histComplementRefreshControls(c);
    histComplementStatus(c, 'Envoi de votre complément…');

    var url = ctrl.endpoint + '/' + encodeURIComponent(c.reference) + '/complement';
    window.fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Idempotency-Key': key
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      var status = res ? res.status : 0;
      if (status === 200) {
        return readJsonSafe(res).then(function (d) { histComplementOnSuccess(c, d); });
      }
      return readJsonSafe(res).then(function (d) { histComplementOnError(c, status, d); });
    }).catch(function () {
      // Incertitude réseau : clé ET payload conservés à l'identique pour un réessai.
      c.submitting = false;
      if (!histComplementIsCurrent(c)) { return; }
      histComplementStatus(c, '');
      histComplementRefreshControls(c);
      histComplementError(c, 'Connexion interrompue. Vos photographies sont conservées : réessayez.');
    });
  }

  function histComplementOnSuccess(c, d) {
    var ctrl = c.ctrl;
    c.submitting = false;
    // Réponse arrivée après un retour à la liste ou un changement de demande :
    // aucun bandeau, aucun rechargement — rien n'est appliqué à une autre demande.
    if (!histComplementIsCurrent(c)) { return; }

    var body = d && typeof d === 'object' ? (d.data && typeof d.data === 'object' ? d.data : d) : {};
    var applied = body.applied === true;
    // Le statut annoncé est TOUJOURS celui renvoyé par le serveur : un rejeu ne
    // laisse jamais croire à un nouveau passage en étude.
    var statusPart = body.status ? (' Statut de la demande : ' + histStatusLabel(body.status) + '.') : '';

    ctrl.complementNotice = {
      tone: applied ? 'success' : 'info',
      text: applied
        ? ('Votre complément a bien été enregistré.' + statusPart)
        : ('Ce complément avait déjà été enregistré : aucun nouvel envoi n’a été effectué.' + statusPart)
    };

    c.submitting = false;
    var ref = c.reference;
    ctrl.complement = null;
    // Détail rechargé (nouvelles photos + statut serveur) et liste remise à jour.
    histFetchList(ctrl, ctrl.currentPage, { keepDetail: true });
    histFetchDetail(ctrl, ref);
  }

  function histComplementOnError(c, status, d) {
    var ctrl = c.ctrl;
    var body = d && typeof d === 'object' ? d : {};
    var code = histComplementCode(body);

    c.submitting = false;
    // Réponse tardive sur une demande qui n'est plus affichée : rien n'est appliqué.
    if (!histComplementIsCurrent(c)) { return; }
    histComplementStatus(c, '');
    histComplementRefreshControls(c);

    if (status === 401) {
      histComplementError(c, 'Votre session a expiré. Reconnectez-vous pour envoyer votre complément.');
      return;
    }
    if (status === 403) {
      // Partenaire non autorisé / inactif → fail-closed, comme /me.
      var portal = ctrl.host.closest ? ctrl.host.closest('[data-pp-root]') : null;
      if (portal) { authFailClosed(portal); }
      histComplementError(c, 'Votre accès partenaire n’est pas actif. Contactez notre équipe.');
      return;
    }
    if (status === 404) {
      histComplementError(c, 'Cette demande n’est plus disponible.');
      return;
    }
    if (status === 409) {
      if (code === 'stale_cycle' || code === 'invalid_transition') {
        // L'état de la demande a changé : on recharge, on ne renvoie JAMAIS
        // automatiquement les photographies sur un nouveau cycle.
        ctrl.complementNotice = {
          tone: 'info',
          text: 'L’état de cette demande a changé depuis l’ouverture de cette page. Vos photographies n’ont pas été envoyées : vérifiez la demande mise à jour avant de recommencer.'
        };
        var staleRef = c.reference;
        ctrl.complement = null;
        histFetchDetail(ctrl, staleRef);
        return;
      }
      histComplementError(c, 'Un envoi différent est déjà en cours de traitement pour cette demande. Rechargez la demande avant de réessayer.');
      return;
    }
    if (status === 422) {
      histComplementApply422(c, body);
      return;
    }
    if (status === 429) {
      histComplementError(c, 'Trop de tentatives. Patientez quelques instants avant de réessayer.');
      return;
    }
    // 500 et autres : réessai autorisé avec la même clé, le payload étant inchangé.
    histComplementError(c, 'Le service est momentanément indisponible. Vos photographies sont conservées : réessayez dans quelques instants.');
  }

  /* Le contrat 422 livré ne porte que { field, code } : les libellés lisibles sont
     produits ici. Un code inconnu retombe sur un message neutre — jamais le code brut. */
  var COMPLEMENT_ERROR_LABELS = {
    validation_failed: 'Certaines informations n’ont pas été acceptées. Vérifiez vos photographies puis réessayez.',
    required: 'Cet élément est obligatoire.',
    invalid: 'Valeur non acceptée.',
    too_long: 'Contenu trop long.',
    too_short: 'Contenu trop court.',
    upload_unreachable: 'Cette photographie n’a pas pu être récupérée. Reprenez la sélection.',
    upload_invalid_host: 'Cette photographie ne provient pas du service d’envoi attendu. Reprenez la sélection.',
    upload_invalid_type: 'Format non accepté. Utilisez JPG, JPEG, PNG ou WEBP.',
    upload_too_large: 'Ce fichier est trop volumineux.',
    invalid_role: 'Cette face ne peut pas être remplacée sur cette demande.',
    duplicate_role: 'Cette face a été transmise deux fois.',
    empty_photos: 'Ajoutez au moins une nouvelle photographie avant l’envoi.',
    stale_cycle: 'L’état de cette demande a changé. Rechargez-la avant de recommencer.'
  };
  /* Un code machine (snake_case sans espace) ne doit jamais être affiché tel quel. */
  function histComplementLabel(code, fallbackMessage) {
    var known = code ? COMPLEMENT_ERROR_LABELS[code] : null;
    if (known) { return known; }
    var msg = histText(fallbackMessage);
    if (msg && !/^[a-z0-9_.]+$/.test(msg)) { return msg; }
    return 'Valeur non acceptée.';
  }

  /* Erreurs de validation replacées près des champs concernés. */
  function histComplementApply422(c, body) {
    var norm = normalize422(body);
    var submitted = histComplementSelectedRoles(c);
    var handled = false;
    var generic = [];

    for (var i = 0; i < norm.fieldErrors.length; i++) {
      var fe = norm.fieldErrors[i];
      var field = histText(fe.field);
      var msg = histComplementLabel(fe.code, fe.message);
      if (field === 'message') {
        histComplementMessageError(c, msg);
        handled = true;
        continue;
      }
      var role = histComplementRoleFromField(field, submitted);
      if (role) {
        histComplementSlotError(c, role, msg);
        handled = true;
        continue;
      }
      generic.push(msg);
    }
    if (generic.length) {
      histComplementError(c, generic.join(' '));
      handled = true;
    }
    if (!handled) {
      histComplementError(c, histComplementLabel(histComplementCode(body), norm.generic));
    }
  }

  /* Résolution d'un champ « photos.N.xxx » vers la face réellement transmise.
     L'index du contrat porte sur le tableau ENVOYÉ : quand seule la face arrière
     est remplacée, photos.0.* désigne « back », jamais « front ».
     Un nom de rôle explicite n'est retenu que s'il fait partie des faces envoyées. */
  function histComplementRoleFromField(field, submittedRoles) {
    if (!field || field.indexOf('photos') !== 0) { return null; }
    var m = field.match(/^photos\.(\d+)/);
    if (m) {
      var idx = parseInt(m[1], 10);
      if (idx >= 0 && idx < submittedRoles.length) { return submittedRoles[idx]; }
      return null;
    }
    for (var i = 0; i < submittedRoles.length; i++) {
      if (field.indexOf(submittedRoles[i]) !== -1) { return submittedRoles[i]; }
    }
    return null;
  }

  function bindGlobalListeners() {
    if (PP.listenersBound) { return; }
    PP.listenersBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    /* Restauration d'un onglet (retour arrière, cache de navigation).

       La page revient telle qu'elle était : cases cochées, champs actifs, et
       AUCUN nouvel appel à /me — le script ne se réexécute pas. Sans ce
       passage, une taille fermée entre-temps redeviendrait cliquable, et un
       ancien choix resterait coché. On repose donc l'état connu de cet onglet.

       Il ne remplace pas le serveur : un onglet ouvert depuis des heures peut
       porter un état périmé, et c'est Laravel qui refusera la taille fermée. */
    window.addEventListener('pageshow', function (event) {
      if (!event || !event.persisted) { return; }
      PP.instances.forEach(function (inst) {
        if (inst && typeof inst.reassertModelAvailability === 'function') {
          inst.reassertModelAvailability();
        }
      });
    });

    // Rechargement de section dans l'éditeur Shopify
    document.addEventListener('shopify:section:load', function (event) {
      var target = event && event.target ? event.target : document;
      if (target.matches && target.matches('[data-pp-root]')) { initAuth(target); }
      if (target.matches && target.matches('[data-pp-request]')) { initRoot(target); }
      initAll(target);
    });
  }

  bindGlobalListeners();
})();
